_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[94],{

/***/ "+ocC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AgencyDetails; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/ple-utils/bookingUtils.js
var bookingUtils = __webpack_require__("vakO");

// EXTERNAL MODULE: ./src/utils/booking-payment-status/bookingPaymentStatus.constants.js
var bookingPaymentStatus_constants = __webpack_require__("ycRU");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.jsx
var BlockLink = __webpack_require__("Onl6");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/hooks/use-authentication/useAuthentication.js
var useAuthentication = __webpack_require__("Iev9");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/widgets/agency-details/AgencyDetails.tracking.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


 // data-selector=BookingsPaymentContactLink

function trackContactLink(_ref) {
  var isQuickLogged = _ref.isQuickLogged,
      context = _ref.context;
  tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    categoryGA: isQuickLogged ? constants["n" /* PLE_QUICK */] : constants["l" /* PLE */],
    labelGA: isQuickLogged ? 'ple_quick_balance_payment' : 'balance_payment',
    actionGA: 'clickToCall'
  }), context);
}
// CONCATENATED MODULE: ./src/client/components/widgets/agency-details/AgencyDetails.jsx
var __jsx = react_default.a.createElement;













function getCallToActionLabel() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isSoldByClubMed = Object(lodash["get"])(props, 'vendor.isSoldByClubMed');
  var displayPriceDetail = Object(lodash["get"])(props, 'cmsContent.memberSpace.trips.price.externalAgencies.displayPriceDetail');

  if (bookingUtils["a" /* default */].shouldDisplayPriceDetail(isSoldByClubMed, displayPriceDetail)) {
    return props.status === bookingPaymentStatus_constants["c" /* BOOKING_PAYMENT_STATUS_OPTION */] ? Object(lodash["get"])(props, 'cmsContent.memberSpace.options.toConfirmLabel') : Object(lodash["get"])(props, 'cmsContent.memberSpace.trips.price.toPayLabel');
  }

  return Object(lodash["get"])(props, 'cmsContent.memberSpace.trips.price.externalAgencies.contactAgencyToGetPriceDetails');
}

function AgencyDetails(props) {
  var _cmsContent$common, _cmsContent$common$pa;

  var isPickYourRoom = props.isPickYourRoom,
      cmsContent = props.cmsContent,
      vendor = props.vendor;
  var context = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isQuickLogged = _useAuthentication.isQuickLogged;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  var callLabel = Object(lodash["get"])(cmsContent, 'common.call');
  var callToActionLabel = getCallToActionLabel(props);
  var pleaseContactExternalLabel = Object(lodash["get"])(cmsContent, 'memberSpace.trips.price.pleaseContactExternalLabel');
  var pleaseContactClubMedLabel = Object(lodash["get"])(cmsContent, 'memberSpace.trips.price.pleaseContactClubMedLabel');
  var agencyPhoneNumber = vendor.isSoldByClubMed && ((_cmsContent$common = cmsContent.common) === null || _cmsContent$common === void 0 ? void 0 : (_cmsContent$common$pa = _cmsContent$common.payment) === null || _cmsContent$common$pa === void 0 ? void 0 : _cmsContent$common$pa.dedicatedPhoneNumber) ? cmsContent.common.payment.dedicatedPhoneNumber : bookingUtils["a" /* default */].getPhoneNumber(vendor, Object(lodash["get"])(cmsContent, 'travelAdvisor.phoneNumber'));
  var shouldRender = agencyPhoneNumber && (isPickYourRoom || callToActionLabel && (vendor.isSoldByClubMed && pleaseContactClubMedLabel || !vendor.isSoldByClubMed && pleaseContactExternalLabel && vendor.name));
  if (!shouldRender) return null;
  var agencyLabel = bookingUtils["a" /* default */].getAgencyLabel(vendor, Object(lodash["get"])(cmsContent, 'memberSpace.trips.price'));
  var formattedPhoneNumber = bookingUtils["a" /* default */].formatPhoneNumber(agencyPhoneNumber) || '';
  var texts = Object(lodash["compact"])([callToActionLabel, agencyLabel, agencyPhoneNumber]);
  return __jsx("div", {
    className: "BookingsView-agencyDetails"
  }, __jsx(BlockLink["a" /* BlockLink */], {
    theme: "black",
    onClick: function onClick() {
      return trackContactLink({
        isQuickLogged: isQuickLogged,
        context: context
      });
    },
    icon: icons["a" /* ICONS */].PHONE_BUBBLE,
    texts: texts,
    url: formattedPhoneNumber
  }), !isTablet ? __jsx(Button["a" /* Button */], {
    url: formattedPhoneNumber,
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    className: "mt-px15",
    onClick: function onClick() {
      return trackContactLink({
        isQuickLogged: isQuickLogged,
        context: context
      });
    }
  }, callLabel) : null);
}

/***/ }),

/***/ "19WB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPrePaymentDetailsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInitPaymentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormDataQuery; });
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pPFN");
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(stringify_object__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _PrePayment_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("XHSI");



function getPrePaymentDetailsQuery(bookingId) {
  return "query {\n    userBooking(bookingId:\"".concat(bookingId, "\") {\n      paymentDetails {\n        duePayment {\n          deadline\n          amount {\n            value\n          }\n        }\n      }\n      information {\n        status\n        bookingId\n        stays {\n          id\n          departureDate\n          returnDate\n          departureCity\n          arrivalCity\n          adults\n          children\n          resort {\n            name\n            image\n            comfort\n            type\n            icon\n            badgeIcon\n            isExplicitEC\n            isJoyview\n            destination {\n              country\n            }\n            departureCity\n            arrivalCity\n          }\n        }\n        vendor {\n          isSoldByClubMed\n          name\n          phoneNumber\n        }\n        isPaid\n      }\n    }\n\n    legalInformations {\n      optionConfirmation {\n        id\n        label\n        description\n        url\n        required\n        preChecked\n      }\n    }\n\n    paymentProviders {\n      id\n      label\n      logo\n      description\n      requiredDelayBeforeDeparture\n      paymentMethods {\n        id\n        label\n        image\n        category\n        timePaymentConditions {\n          id\n          paymentCount\n          chargePercentage\n        }\n      }\n      token {\n        format\n        value\n      }\n    }\n  }");
}
function getInitPaymentQuery(payload) {
  var _payload$bookingId = payload.bookingId,
      bookingId = _payload$bookingId === void 0 ? '' : _payload$bookingId,
      service = payload.service,
      _payload$action = payload.action,
      action = _payload$action === void 0 ? '' : _payload$action;
  var roomSelectionServicePayload = stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'roomSelectionServicePayload', null), {
    singleQuotes: false
  });
  var stringifiedService = stringify_object__WEBPACK_IMPORTED_MODULE_0___default()({
    amount: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'amount', null),
    currency: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'currency', null)
  }, {
    singleQuotes: false
  });
  return "query {\n    prePayment(bookingId: \"".concat(bookingId, "\", service: ").concat(stringifiedService, ", roomSelectionServicePayload:").concat(roomSelectionServicePayload, ", action:\"").concat(action, "\") {\n      due {\n        value\n        formattedValue(precision: 2)\n        currency\n      }\n      paymentSchedule {\n        deposit {\n          value\n          formattedValue(precision: 2)\n        }\n        remainingBalance {\n          value\n          formattedValue(precision: 2)\n        }\n        dueDate\n      }\n      bookingBalance(precision: 2)\n      serviceFormattedPrice(precision: 2)\n      remainingCreditBalance(precision: 2)\n    }\n  }");
}
function getFormDataQuery(_ref) {
  var bookingId = _ref.bookingId,
      providerId = _ref.providerId,
      redirectUri = _ref.redirectUri,
      amount = _ref.amount,
      currency = _ref.currency,
      service = _ref.service,
      redirectCancelUrl = _ref.redirectCancelUrl,
      responsive = _ref.responsive,
      paymentConditionId = _ref.paymentConditionId,
      action = _ref.action,
      tokenParam = _ref.token,
      isIframe = _ref.isIframe,
      iframeCallbackUrl = _ref.iframeCallbackUrl;
  var paymentConditionQuery = paymentConditionId ? "paymentConditionId : \"".concat(paymentConditionId, "\"") : '';
  var act = action ? "action: \"".concat(action, "\"") : '';
  var token = tokenParam ? "token: \"".concat(tokenParam, "\"") : '';
  return "mutation {\n    bookingsPaymentRedirect: bookingPaymentRedirect (\n      bookingId: \"".concat(bookingId, "\",\n      providerId:\"").concat(providerId, "\",\n      redirectUri: \"").concat(redirectUri, "\",\n      redirectCancelUrl:\"").concat(redirectCancelUrl, "\",\n      amount: ").concat(amount, ",\n      currency:\"").concat(currency, "\",\n      packages: ").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'packages', []), {
    singleQuotes: false
  }), ",\n      additionalService:").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'additionalService', null), {
    singleQuotes: false
  }), ",\n      roomSelectionServices:").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'roomSelectionServicePayload', null), {
    singleQuotes: false
  }), ",\n      device: \"").concat(Object(_PrePayment_helpers__WEBPACK_IMPORTED_MODULE_2__[/* getDevice */ "c"])(responsive), "\"\n      ").concat(paymentConditionQuery, "\n      ").concat(act, "\n      ").concat(token, "\n      isIframePayment: ").concat((isIframe || false).toString(), "\n      iframeCallbackUrl: \"").concat(iframeCallbackUrl, "\"\n    ) {\n      url\n      fields\n      method\n      bookingId\n      customerId\n      orderId\n      price {\n        value\n      }\n    }\n  }");
}

/***/ }),

/***/ "1dAi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (re) {
	return Object.prototype.toString.call(re) === '[object RegExp]';
};


/***/ }),

/***/ "4M6q":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/pickYourRoomAgencyView",
      function () {
        return __webpack_require__("xjFj");
      }
    ]);
  

/***/ }),

/***/ "Dknd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PYRResortRequestForm; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MWZw");
/* harmony import */ var _frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VO9w");
/* harmony import */ var _frameworks_form_inputs_radio_button_RadioButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("zwQs");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("SPKZ");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var UPDATE_COMMENT = 'UPDATE_COMMENT';
var UPDATE_EMAIL = 'UPDATE_EMAIL';
var TOGGLE_CRITERIA = 'TOGGLE_CRITERIA';
var getInitialState = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["memoize"])(function (_ref) {
  var bookingId = _ref.bookingId,
      criteriaId = _ref.criteriaId,
      criteriaValue = _ref.criteriaValue;
  return {
    criteriasStatus: Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      criteria1: false,
      criteria2: false,
      criteria3: false,
      criteria4: false,
      criteria5: false
    }, criteriaId, true),
    formState: {
      bookingId: bookingId,
      criteria: criteriaValue,
      comment: '',
      contactEmail: ''
    }
  };
});

function reducer(state, action) {
  switch (action.type) {
    case UPDATE_COMMENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        formState: _objectSpread(_objectSpread({}, state.formState), {}, {
          comment: action.payload
        })
      });

    case UPDATE_EMAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        formState: _objectSpread(_objectSpread({}, state.formState), {}, {
          contactEmail: action.payload
        })
      });

    case TOGGLE_CRITERIA:
      var _action$payload = action.payload,
          id = _action$payload.id,
          value = _action$payload.value;
      return _objectSpread(_objectSpread({}, state), {}, {
        criteriasStatus: Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
          criteria1: false,
          criteria2: false,
          criteria3: false,
          criteria4: false,
          criteria5: false
        }, id, true),
        formState: _objectSpread(_objectSpread({}, state.formState), {}, {
          criteria: value
        })
      });

    default:
      return state;
  }
}

var buildCriteriaComponent = function buildCriteriaComponent(_ref2) {
  var getLabel = _ref2.getLabel,
      isChecked = _ref2.isChecked,
      makeOnClick = _ref2.makeOnClick;
  return function (_ref3) {
    var id = _ref3.id;
    var label = getLabel(id);
    return __jsx("button", {
      className: "reset-button inline-flex justify-start items-center mb-px30 w-full md:w-1/3",
      "data-testid": "PYRResortOnlyLayer--".concat(id),
      onClick: makeOnClick(id, label),
      type: "button"
    }, __jsx(_frameworks_form_inputs_radio_button_RadioButton__WEBPACK_IMPORTED_MODULE_5__[/* RadioButton */ "a"], {
      isChecked: isChecked(id)
    }), __jsx("div", {
      className: "ml-px5"
    }, label));
  };
};

function PYRResortRequestForm(_ref4) {
  var i18n = _ref4.i18n,
      bookingId = _ref4.bookingId,
      onSubmit = _ref4.onSubmit,
      onDisplayMapClick = _ref4.onDisplayMapClick,
      handleError = _ref4.handleError,
      agency = _ref4.agency;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_1__["useReducer"])(reducer, getInitialState({
    bookingId: bookingId,
    criteriaId: 'criteria1',
    criteriaValue: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'memberSpace.pickYourRoom.resortOnly.selectCriteria.criteria1')
  })),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(''),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var Criteria = buildCriteriaComponent({
    makeOnClick: function makeOnClick(id, value) {
      return function () {
        return dispatch({
          type: TOGGLE_CRITERIA,
          payload: {
            id: id,
            value: value
          }
        });
      };
    },
    getLabel: function getLabel(id) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'memberSpace.pickYourRoom.resortOnly.selectCriteria.' + id);
    },
    isChecked: function isChecked(id) {
      return state.criteriasStatus[id];
    }
  });
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx("div", null, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_3__[/* Title */ "a"], {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__[/* ICONS */ "a"].TOUR
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'memberSpace.pickYourRoom.resortOnly.selectCriteria.title')), __jsx("div", {
    className: "mt-px30"
  }, __jsx(Criteria, {
    id: "criteria1"
  }), __jsx(Criteria, {
    id: "criteria2"
  }), __jsx(Criteria, {
    id: "criteria3"
  }), __jsx(Criteria, {
    id: "criteria4"
  }), __jsx(Criteria, {
    id: "criteria5"
  }))), __jsx("div", {
    className: "text-right"
  }, __jsx("a", {
    onClick: onDisplayMapClick,
    className: "cursor-pointer underline"
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'memberSpace.pickYourRoom.resortOnly.seeResortMapCTA'))), __jsx("div", {
    className: "mt-px30"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_3__[/* Title */ "a"], {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__[/* ICONS */ "a"].PEN
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'memberSpace.pickYourRoom.resortOnly.comment')), __jsx("textarea", {
    "data-testid": "PYRResortOnlyLayer--comment",
    rows: 4,
    className: "mt-px15 w-full",
    style: {
      border: 'solid 1px silver'
    },
    value: state.formState.comment,
    onChange: function onChange(e) {
      return dispatch({
        type: UPDATE_COMMENT,
        payload: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(e, 'target.value', '')
      });
    }
  })), agency && __jsx("div", null, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_3__[/* Title */ "a"], {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__[/* ICONS */ "a"].ANSWERS
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'agency.pickYourRoom.resortOnly.emailAddress')), __jsx("input", {
    type: "email",
    style: {
      border: '1px solid silver'
    },
    className: "mt-px15 w-full md:w-2/3",
    "data-testid": "PYRResortOnlyLayer--email",
    onChange: function onChange(e) {
      return dispatch({
        type: UPDATE_EMAIL,
        payload: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(e, 'target.value', '')
      });
    }
  })), __jsx(_frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_4__[/* Notification */ "a"], {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__[/* ICONS */ "a"].WARNING,
    className: "PYRResortOnlyLayer--priceInformation",
    text: agency ? Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'agency.pickYourRoom.resortOnly.priceInformation') : Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'memberSpace.pickYourRoom.resortOnly.priceInformation')
  }), __jsx("hr", null), __jsx("div", {
    className: "flex justify-between flex-col md:flex-row"
  }, errorMessage ? __jsx("div", {
    className: "flex items-center text-danger"
  }, errorMessage) : __jsx("div", null), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
    isLoading: isSubmitting,
    isDisabled: agency && !state.formState.contactEmail,
    className: "bg-turquoise w-full md:w-auto",
    dataSelector: "sendRequestCTA",
    onClick: function onClick() {
      if (isSubmitting) return Promise.resolve();
      setIsSubmitting(true);
      return onSubmit(agency ? state.formState : Object(lodash__WEBPACK_IMPORTED_MODULE_2__["omit"])(state.formState, 'contactEmail')).then(function (value) {
        setIsSubmitting(false);
        setErrorMessage('');
        return value;
      }).catch(function (e) {
        setIsSubmitting(false);
        setErrorMessage(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'memberSpace.pickYourRoom.errors.unhandled.title', 'An error occured'));
        handleError && handleError(e);
      });
    }
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'memberSpace.pickYourRoom.resortOnly.sendRequestCTA'))));
}

/***/ }),

/***/ "EkEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentButton; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("uDfI");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");
/* harmony import */ var _router_useRouter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7jla");
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UCZK");
/* harmony import */ var _components_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("e0Ti");
/* harmony import */ var _components_frameworks_form_feedback_FormFeedback_jsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DwNm");
/* harmony import */ var _pre_payment_PrePayment_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("XHSI");

var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;










var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        isLoading: true,
        isOnError: false
      };

    case 'SET_SUCCESS':
      return {
        isLoading: false,
        isOnError: false
      };

    case 'SET_ERROR':
      return {
        isLoading: false,
        isOnError: true
      };

    default:
      throw new Error("PaymentButton's reducer called with unknown action of type ".concat(action.type));
  }
};

function PaymentButton(props) {
  var label = props.label,
      errorLabel = props.errorLabel,
      payload = props.payload,
      isFullWidth = props.isFullWidth,
      dataSelector = props.dataSelector,
      _onClick = props.onClick,
      color = props.color,
      _props$withNotificati = props.withNotificationError,
      withNotificationError = _props$withNotificati === void 0 ? false : _props$withNotificati,
      _props$isFreeDeposit = props.isFreeDeposit,
      isFreeDeposit = _props$isFreeDeposit === void 0 ? false : _props$isFreeDeposit;
  var appContext = react__WEBPACK_IMPORTED_MODULE_2___default.a.useContext(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]);

  var _useRouter = Object(_router_useRouter__WEBPACK_IMPORTED_MODULE_5__[/* useRouter */ "a"])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var _React$useReducer = react__WEBPACK_IMPORTED_MODULE_2___default.a.useReducer(reducer, {
    isLoading: false,
    isOnError: false
  }),
      _React$useReducer2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_React$useReducer, 2),
      _React$useReducer2$ = _React$useReducer2[0],
      isOnError = _React$useReducer2$.isOnError,
      isLoading = _React$useReducer2$.isLoading,
      dispatch = _React$useReducer2[1];

  var reduxDispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_3__[/* useDispatch */ "d"])();
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (withNotificationError && isOnError) {
      reduxDispatch({
        type: 'PAYMENT_BUTTON_ERROR',
        payload: {
          toastLabel: errorLabel
        }
      });
    }
  }, [isOnError, withNotificationError]);
  var theme = isFreeDeposit ? 'anchor' : 'default';
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PaymentButton--container', {
      'w-full': isFullWidth
    })
  }, isOnError && !withNotificationError ? __jsx(_components_frameworks_form_feedback_FormFeedback_jsx__WEBPACK_IMPORTED_MODULE_8__[/* FormFeedback */ "a"], {
    isError: true,
    message: errorLabel
  }) : __jsx("div", null), __jsx(_components_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_7__[/* Button */ "a"], {
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }

      dispatch({
        type: 'SET_LOADING'
      });
      Object(_pre_payment_PrePayment_helpers__WEBPACK_IMPORTED_MODULE_9__[/* buildPrePaymentUrlAndRedirect */ "a"])({
        appContext: appContext,
        history: history,
        location: location,
        payload: payload,
        isFreeDeposit: isFreeDeposit
      }).then(function () {
        dispatch({
          type: 'SET_SUCCESS'
        });
      }).catch(function () {
        dispatch({
          type: 'SET_ERROR'
        });
      });
    },
    isLoading: isLoading,
    dataSelector: dataSelector,
    dataTestId: dataSelector,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
      'w-full': isFullWidth
    }),
    colorBg: color ? color : _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_6__[/* COLORS */ "a"].BOOKING,
    colorBorder: color ? color : _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_6__[/* COLORS */ "a"].BOOKING,
    theme: theme
  }, label));
}

/***/ }),

/***/ "I8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = Object.prototype.toString;

module.exports = function (x) {
  var prototype;
  return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};

/***/ }),

/***/ "Nhxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attributesToString; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pPFN");
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(stringify_object__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable no-duplicate-imports  */


function attributesToString(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(data).reduce(function (acc, key) {
    if (options.ignoreUndefined && data[key] === undefined) {
      return '';
    }

    var value = data[key] === null ? '' : data[key];
    var dataToString = Array.isArray(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isBoolean"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isObject"])(value) ? stringify_object__WEBPACK_IMPORTED_MODULE_1___default()(value, {
      singleQuotes: false,
      inlineCharacterLimit: 1024,
      filter: function filter(o, p) {
        return options.ignoreUndefined ? o[p] !== undefined : true;
      }
    }) : "\"".concat(value, "\"");
    return "".concat(acc).concat(key, " : ").concat(dataToString, " ");
  }, '');
}

/***/ }),

/***/ "OJR3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PickYourRoomWrapperContainer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/store/pick-your-room/map/map.actions.js
var map_actions = __webpack_require__("lYD5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/hooks/use-authentication/useAuthentication.js
var useAuthentication = __webpack_require__("Iev9");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./src/client/store/pick-your-room/app/pickYourRoom.actions.js + 1 modules
var pickYourRoom_actions = __webpack_require__("vdc/");

// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/map/Map.container.js





var Map = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(39), __webpack_require__.e(44)]).then(__webpack_require__.bind(null, "d6ko"));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("d6ko")];
    },
    modules: ["./Map.jsx"]
  }
});

var Map_container_mapStateToProps = function mapStateToProps(state) {
  var _state$pickYourRoom = state.pickYourRoom,
      app = _state$pickYourRoom.app,
      mapper = _state$pickYourRoom.mapper;
  return {
    amenities: mapper.amenities,
    baseViewport: mapper.baseViewport,
    currentBounds: mapper.currentBounds,
    maxBounds: mapper.maxBounds,
    mapStyle: Object(lodash["get"])(state, 'pickYourRoom.mapper.mapStyle'),
    targetViewport: mapper.targetViewport,
    completedIntro: app.completedIntro,
    currentSelectedRoomIndex: app.currentSelectedRoomIndex,
    highlightedRoom: app.highlightedRoom,
    filteredRoomsForCurrentFloor: app.filteredRoomsForCurrentFloor,
    selectedBuildingId: app.selectedBuildingId,
    selectedRooms: app.selectedRooms
  };
};

var Map_container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    completeIntro: function completeIntro() {
      dispatch(Object(pickYourRoom_actions["a" /* completeIntro */])());
    },
    highlightBuilding: function highlightBuilding(feature) {
      dispatch(Object(map_actions["c" /* highlightBuilding */])(feature === undefined ? '' : feature.properties.building_id));
    },
    select3DGeometry: function select3DGeometry(feature) {
      if (feature) {
        dispatch(Object(pickYourRoom_actions["e" /* selectBuilding */])(feature.properties.building_id));
      }
    },
    selectRoom: function selectRoom(roomId, appContext) {
      dispatch(Object(pickYourRoom_actions["g" /* selectRoom */])(roomId, appContext));
    },
    highlightRoom: function highlightRoom(roomId) {
      dispatch(Object(pickYourRoom_actions["b" /* highlightRoom */])(roomId));
    }
  };
};

/* harmony default export */ var Map_container = (Object(es["c" /* connect */])(Map_container_mapStateToProps, Map_container_mapDispatchToProps)(Map));
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/heroUtils.js
var heroUtils = __webpack_require__("5xkM");

// EXTERNAL MODULE: ./src/client/components/widgets/cart/bookingCart.actions.js
var bookingCart_actions = __webpack_require__("kD/R");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/components/hoc/map-context-to-props/mapContextToProps.jsx
var mapContextToProps = __webpack_require__("ggkm");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx + 2 modules
var TrackingPageLoad = __webpack_require__("TVUe");

// EXTERNAL MODULE: ./src/client/components/widgets/agency-details/AgencyDetails.jsx + 1 modules
var AgencyDetails = __webpack_require__("+ocC");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/views/account/bookings/sections/payment/PaymentButton.jsx
var PaymentButton = __webpack_require__("EkEL");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/payment-button/PYRPaymentButton.utils.js
function getRoomSelectionServiceDatas(selectedRoomsInfos) {
  var tmpService = {};
  var tmpAccommodation = {};
  return selectedRoomsInfos.reduce(function (result, infos) {
    if (!tmpService[infos.serviceId]) {
      tmpService[infos.serviceId] = {
        id: infos.serviceId,
        accommodations: []
      };
      result.roomSelectionServicePayload.push(tmpService[infos.serviceId]);
    }

    if (!tmpAccommodation[infos.serviceId + '-' + infos.accommodationId]) {
      tmpAccommodation[infos.serviceId + '-' + infos.accommodationId] = {
        id: infos.accommodationId,
        rooms: []
      };
      tmpService[infos.serviceId].accommodations.push(tmpAccommodation[infos.serviceId + '-' + infos.accommodationId]);
    }

    tmpAccommodation[infos.serviceId + '-' + infos.accommodationId].rooms.push({
      id: infos.roomId
    });

    if (result.currency === null) {
      result.currency = infos.unitPrice.currency;
    }

    result.amount += infos.unitPrice.amount;
    return result;
  }, {
    amount: 0,
    currency: null,
    roomSelectionServicePayload: []
  });
}

/* harmony default export */ var PYRPaymentButton_utils = ({
  getRoomSelectionServiceDatas: getRoomSelectionServiceDatas
});
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/payment-button/PYRPaymentButton.jsx
var __jsx = react_default.a.createElement;
















function DirectPayment(_ref) {
  var selectedRoomsInfos = _ref.selectedRoomsInfos,
      stayWithVendor = _ref.stayWithVendor,
      beforeRedirect = _ref.beforeRedirect,
      cmsContent = _ref.cmsContent,
      label = _ref.label,
      dataSelector = _ref.dataSelector,
      color = _ref.color,
      onClick = _ref.onClick,
      errorLabel = _ref.errorLabel;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var currentUri = Object(uriUtils["c" /* convertLocationToURI */])(location);

  var _utils$getRoomSelecti = PYRPaymentButton_utils.getRoomSelectionServiceDatas(selectedRoomsInfos),
      amount = _utils$getRoomSelecti.amount,
      currency = _utils$getRoomSelecti.currency,
      roomSelectionServicePayload = _utils$getRoomSelecti.roomSelectionServicePayload;

  var bookingId = stayWithVendor.bookingId;
  var stayId = stayWithVendor.stayId;
  var prepareMyStayDirectory = new URI_default.a(currentUri.protocol() + '://' + currentUri.host() + Object(routeBuilder["a" /* buildUrl */])('prepareMyStay', {
    bookingId: bookingId,
    stayId: stayId
  }, Object(lodash["pick"])(URI_default.a.parseQuery(currentUri.search()), ['locale']))).toString();
  return __jsx(PaymentButton["a" /* PaymentButton */], {
    payload: {
      bookingId: bookingId,
      stayId: stayId,
      service: {
        name: Object(lodash["get"])(cmsContent, 'memberSpace.prepareMyStay.pickYourRoom.title'),
        amount: amount,
        currency: currency,
        roomSelectionServicePayload: roomSelectionServicePayload
      },
      backUrl: currentUri.toString(),
      redirectCancelUrl: currentUri.toString(),
      urlRedirectionIfNothingToPay: prepareMyStayDirectory,
      beforeRedirect: beforeRedirect
    },
    label: label,
    errorLabel: errorLabel,
    dataSelector: dataSelector,
    color: color,
    onClick: onClick
  });
}

function PYRPaymentButton(_ref2) {
  var stayWithVendor = _ref2.stayWithVendor,
      label = _ref2.label,
      dataSelector = _ref2.dataSelector,
      color = _ref2.color,
      cmsContent = _ref2.cmsContent,
      onClick = _ref2.onClick,
      canUseOnlinePayment = _ref2.canUseOnlinePayment,
      fidelityStatus = _ref2.fidelityStatus,
      errorLabel = _ref2.errorLabel,
      beforeRedirect = _ref2.beforeRedirect,
      selectedRoomsInfos = _ref2.selectedRoomsInfos;
  var vendor = stayWithVendor.vendor;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var isDirect = Object(lodash["get"])(vendor, 'isSoldByClubMed', false);

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isQuickLogged = _useAuthentication.isQuickLogged;

  var PLEPrefix = Object(utils["a" /* getPLECategoryGA */])(isQuickLogged);
  var pageName = isDirect ? "".concat(PLEPrefix.toLowerCase(), "_pickYourRoom_details_direct") : "".concat(PLEPrefix.toLowerCase(), "_pickYourRoom_details_indirect");
  var trackProps = {
    event: 'virtualPageLoadingDataLayer',
    pageName: pageName,
    fidelityStatus: fidelityStatus
  };
  return __jsx("div", {
    className: "flex justify-between"
  }, __jsx(TrackingPageLoad["a" /* TrackingPageLoad */], trackProps), isDirect && canUseOnlinePayment ? __jsx(react_default.a.Fragment, null, Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('pickYourRoom.cartModeEnabled') ? __jsx(Button["a" /* Button */], {
    dataSelector: dataSelector,
    colorBg: color,
    onClick: onClick
  }, label) : __jsx(DirectPayment, {
    selectedRoomsInfos: selectedRoomsInfos,
    stayWithVendor: stayWithVendor,
    beforeRedirect: beforeRedirect,
    cmsContent: cmsContent,
    label: label,
    errorLabel: errorLabel,
    dataSelector: dataSelector,
    color: color,
    onClick: onClick
  })) : __jsx(AgencyDetails["a" /* AgencyDetails */], {
    isPickYourRoom: true,
    cmsContent: cmsContent,
    vendor: vendor
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/payment-button/PYRPaymentButton.container.js







function sendPlatinumTracking(fidelityStatus, appContext) {
  Object(tracking_api["b" /* setDataLayer */])({
    event: 'eventGA',
    categoryGA: 'PLE',
    actionGA: 'pickYourRoom',
    labelGA: 'confirmation',
    fidelityStatus: fidelityStatus,
    valueGA: 0,
    nonInteraction: 0
  }, appContext);
}

var PYRPaymentButton_container_mapStateToProps = function mapStateToProps(_ref, props) {
  var app = _ref.pickYourRoom.app;
  return {
    stayWithVendor: app.stayWithVendor,
    fidelityStatus: app.fidelityStatus,
    beforeRedirect: function beforeRedirect() {
      return sendPlatinumTracking(app.fidelityStatus, props.appContext);
    }
  };
};

var PYRPaymentButton_container_mapDispatchToProps = {
  updateCart: bookingCart_actions["c" /* updateBookingCart */]
};
/* harmony default export */ var PYRPaymentButton_container = (Object(lodash["flowRight"])([Object(mapContextToProps["a" /* default */])(function (appContext) {
  return {
    canUseOnlinePayment: appContext.canUseOnlinePayment
  };
}), Object(es["c" /* connect */])(PYRPaymentButton_container_mapStateToProps, PYRPaymentButton_container_mapDispatchToProps)])(PYRPaymentButton));
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/room-card/RoomCard.jsx





var RoomCard_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





var RoomCard_RoomCard = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(RoomCard, _React$Component);

  var _super = _createSuper(RoomCard);

  function RoomCard() {
    Object(classCallCheck["a" /* default */])(this, RoomCard);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(RoomCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          title = _this$props.title,
          number = _this$props.number,
          showCTA = _this$props.showCTA,
          onSelect = _this$props.onSelect,
          image = _this$props.image,
          ctaText = _this$props.ctaText,
          modifyText = _this$props.modifyText;
      var label = showCTA ? ctaText : modifyText;
      var mediaServerImage = image ? Object(heroUtils["e" /* getBackgroundImageUrl */])(image, 400) : '';
      return RoomCard_jsx("div", {
        className: "room-card"
      }, RoomCard_jsx("div", {
        className: "room-card-image",
        style: {
          backgroundImage: "url(\"".concat(mediaServerImage, "\")")
        }
      }), RoomCard_jsx("div", {
        className: "room-card-content"
      }, RoomCard_jsx("div", {
        className: "room-card-info"
      }, RoomCard_jsx("span", null, title), RoomCard_jsx("span", null, number)), RoomCard_jsx(Button["a" /* Button */], {
        className: "self-end",
        dataSelector: "SelectRoom-Button",
        onClick: function onClick() {
          onSelect(id);
        }
      }, label)));
    }
  }]);

  return RoomCard;
}(react_default.a.Component);

/* harmony default export */ var room_card_RoomCard = (RoomCard_RoomCard);
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/room-selector/RoomSelector.jsx
var RoomSelector_jsx = react_default.a.createElement;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












function makeGetRoomInfos(selectableRooms) {
  return function (properties) {
    var _ref = properties || {},
        id = _ref.id,
        label = _ref.label;

    var _iterator = _createForOfIteratorHelper(selectableRooms),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var selectableRoom = _step.value;
        var room = selectableRoom.rooms.find(function (r) {
          return r.id === id;
        });

        if (room) {
          return {
            accommodationId: selectableRoom.id,
            serviceId: selectableRoom._serviceId,
            unitPrice: selectableRoom._unitPrice,
            roomId: id,
            roomLabel: label
          };
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return {};
  };
}

function RoomSelector(props) {
  var selectableRooms = props.selectableRooms,
      selectedRooms = props.selectedRooms,
      startRoomSelection = props.startRoomSelection,
      numRoomsLeftToPick = props.numRoomsLeftToPick,
      cmsContent = props.cmsContent,
      fidelityStatus = props.fidelityStatus,
      cart = props.cart,
      _props$stayWithVendor = props.stayWithVendor,
      stayWithVendor = _props$stayWithVendor === void 0 ? {} : _props$stayWithVendor,
      fetchBookingCart = props.fetchBookingCart;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var getRoomInfos = makeGetRoomInfos(selectableRooms);
  var selectedRoomsInfos = selectedRooms.map(function (room) {
    return getRoomInfos(room.properties);
  });

  var _utils$getRoomSelecti = PYRPaymentButton_utils.getRoomSelectionServiceDatas(selectedRoomsInfos),
      roomSelectionServicePayload = _utils$getRoomSelecti.roomSelectionServicePayload;

  Object(react["useEffect"])(function () {
    if (numRoomsLeftToPick === 0 && // Only for updating cart
    Object(lodash["get"])(cart, 'pickRoom', []).length > 0) {
      var reduceToRoomId = function reduceToRoomId(acc, src) {
        return acc.concat((src.accommodations || []).reduce(function (a, b) {
          return a.concat(b.rooms.map(function (_ref2) {
            var id = _ref2.id;
            return id;
          }));
        }, []));
      };

      roomSelectionServicePayload.forEach(function (srv) {
        var serviceInCart = Object(lodash["get"])(cart, 'pickRoom', []).find(function (_ref3) {
          var id = _ref3.id;
          return id === srv.id;
        }) || {};
        var shouldUpdate = reduceToRoomId([], srv).join(',') !== reduceToRoomId([], serviceInCart).join(',');

        if (shouldUpdate) {
          Object(bookingCart_actions["e" /* updateBookingCartSequencially */])([{
            id: srv.id,
            // $FlowFixMe I do not why
            bookingId: stayWithVendor.bookingId,
            context: appContext,
            action: 'remove',
            serviceName: 'ROOM_SELECTION_SERVICE'
          }, {
            id: srv.id,
            // $FlowFixMe I do not why
            bookingId: stayWithVendor.bookingId,
            accommodations: srv.accommodations,
            context: appContext,
            action: 'update',
            serviceName: 'ROOM_SELECTION_SERVICE'
          }]).then(function () {
            return fetchBookingCart(stayWithVendor, appContext);
          });
        }
      });
    }
  });
  return RoomSelector_jsx("div", null, selectableRooms.map(function (room, i) {
    var title = room.label;
    var hasAlreadySelected = selectedRooms[i] !== undefined;
    var number = hasAlreadySelected ? "n\xBA".concat(selectedRooms[i].properties.id) : '';
    return RoomSelector_jsx(room_card_RoomCard, {
      key: "room-".concat(i),
      id: i,
      title: title,
      number: number,
      onSelect: function onSelect(roomIndex) {
        return startRoomSelection(roomIndex, appContext);
      },
      showCTA: !hasAlreadySelected,
      image: room.image,
      ctaText: Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.roomCardCTA'),
      modifyText: Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.roomCardModify'),
      fidelityStatus: fidelityStatus
    });
  }), numRoomsLeftToPick === 0 ? RoomSelector_jsx(react_default.a.Fragment, null, RoomSelector_jsx("div", {
    className: "sidebar-price-details"
  }, RoomSelector_jsx("span", {
    className: "sidebar-price-details-title"
  }, RoomSelector_jsx("span", null, Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.priceDetails'))), selectedRoomsInfos.map(function (roomInfos, i) {
    return RoomSelector_jsx("div", {
      key: "selectedRoom-".concat(i),
      className: "sidebar-price-details-item"
    }, RoomSelector_jsx("span", null, Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.pickMyRoom'), ": n\xBA", roomInfos.roomLabel), RoomSelector_jsx("span", {
      className: "sidebar-price-details-item-price"
    }, roomInfos.unitPrice.amount, " ", roomInfos.unitPrice.currency));
  })), RoomSelector_jsx("div", {
    className: "sidebar-footer"
  }, RoomSelector_jsx(PYRPaymentButton_container, {
    cmsContent: cmsContent,
    selectedRoomsInfos: selectedRoomsInfos,
    roomSelectionServicePayload: roomSelectionServicePayload,
    label: Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.continueCTA'),
    dataSelector: "PYRPaymentButton-main-CTA",
    color: colors["a" /* COLORS */].BOOKING,
    stayWithVendor: stayWithVendor,
    errorLabel: cmsContent.memberSpace.pickYourRoom.errors.unhandled.title,
    onClick: function onClick() {
      Object(tracking_api["b" /* setDataLayer */])({
        categoryGA: 'ple-prepare-my-stay',
        actionGA: 'pickYourRoom',
        labelGA: 'pay',
        fidelityStatus: fidelityStatus
      }, appContext);

      if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('pickYourRoom.cartModeEnabled')) {
        Object(bookingCart_actions["d" /* updateBookingCartAll */])(roomSelectionServicePayload.map(function (srv) {
          return {
            id: srv.id,
            bookingId: stayWithVendor.bookingId,
            accommodations: srv.accommodations,
            context: appContext,
            action: 'update',
            serviceName: 'ROOM_SELECTION_SERVICE'
          };
        })).then(function () {
          return fetchBookingCart(stayWithVendor, appContext);
        });
      }
    }
  }))) : RoomSelector_jsx("div", {
    className: "sidebar-footer--message-only"
  }, Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.selectInstructions')));
}

/* harmony default export */ var room_selector_RoomSelector = (RoomSelector);
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/room-selector/RoomSelector.container.js






var RoomSelector_container_mapStateToProps = function mapStateToProps(state) {
  var app = state.pickYourRoom.app,
      memberSpace = state.memberSpace;
  return {
    cart: Object(lodash["get"])(memberSpace, 'bookingCart.data.userBooking.cart') || {},
    selectableRooms: app.selectableRooms,
    selectedRooms: app.selectedRooms,
    numRoomsLeftToPick: app.numRoomsLeftToPick,
    selectableRoomsUnitPrice: app.selectableRoomsUnitPrice,
    errors: app.errors,
    fidelityStatus: app.fidelityStatus,
    stayWithVendor: app.stayWithVendor
  };
};

var RoomSelector_container_mapDispatchToProps = {
  startRoomSelection: pickYourRoom_actions["h" /* startRoomSelection */],
  fetchBookingCart: bookingCart_actions["b" /* fetchBookingCart */]
};
/* harmony default export */ var RoomSelector_container = (Object(es["c" /* connect */])(RoomSelector_container_mapStateToProps, RoomSelector_container_mapDispatchToProps)(room_selector_RoomSelector));
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/className/className.util.js
var className_util = __webpack_require__("wJdf");

// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/accordion/PYRAccordion.jsx





var PYRAccordion_jsx = react_default.a.createElement;

function PYRAccordion_createSuper(Derived) { var hasNativeReflectConstruct = PYRAccordion_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function PYRAccordion_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var PYRAccordion_PYRAccordion = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(PYRAccordion, _React$Component);

  var _super = PYRAccordion_createSuper(PYRAccordion);

  function PYRAccordion() {
    Object(classCallCheck["a" /* default */])(this, PYRAccordion);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(PYRAccordion, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          floor = _this$props.floor,
          rooms = _this$props.rooms,
          selected = _this$props.selected,
          onTitleClick = _this$props.onTitleClick,
          onItemClick = _this$props.onItemClick,
          onItemHover = _this$props.onItemHover;
      var classModifier = selected === false ? 'closed' : 'default';
      return PYRAccordion_jsx("div", {
        className: "PYRAccordion"
      }, PYRAccordion_jsx("div", {
        className: "PYRAccordion-header",
        onClick: function onClick() {
          return onTitleClick(floor.id);
        }
      }, PYRAccordion_jsx("div", {
        className: Object(className_util["b" /* getClassWithModifiers */])('PYRAccordion-header-title', [classModifier])
      }, floor.label)), PYRAccordion_jsx("div", {
        onMouseLeave: function onMouseLeave() {
          return onItemHover();
        },
        className: Object(className_util["b" /* getClassWithModifiers */])('PYRAccordion-content', [classModifier])
      }, rooms.map(function (room) {
        return PYRAccordion_jsx("div", {
          key: room.properties.id,
          onClick: function onClick() {
            return onItemClick(room.properties.id);
          },
          onMouseEnter: function onMouseEnter() {
            return onItemHover(room.properties.id);
          },
          className: "PYRAccordion-item"
        }, PYRAccordion_jsx("div", {
          className: "PYRAccordion-item-title"
        }, room.properties.id));
      })));
    }
  }]);

  return PYRAccordion;
}(react_default.a.Component);

/* harmony default export */ var accordion_PYRAccordion = (PYRAccordion_PYRAccordion);
// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/room-finder/Room.tracking.js


var Room_tracking_trackRoomSelection = function trackRoomSelection(_ref) {
  var fidelityStatus = _ref.fidelityStatus,
      isQuickLogged = _ref.isQuickLogged,
      context = _ref.context;
  var PLEPrefix = Object(utils["a" /* getPLECategoryGA */])(isQuickLogged);
  Object(tracking_api["b" /* setDataLayer */])({
    event: 'eventGA',
    categoryGA: PLEPrefix,
    actionGA: 'pickYourRoom',
    labelGA: 'roomSelection',
    siteSection: PLEPrefix,
    fidelityStatus: fidelityStatus
  }, context);
};
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/room-finder/RoomFinder.jsx







var RoomFinder_jsx = react_default.a.createElement;

function RoomFinder_createSuper(Derived) { var hasNativeReflectConstruct = RoomFinder_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function RoomFinder_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var RoomFinder_RoomFinder = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(RoomFinder, _React$Component);

  var _super = RoomFinder_createSuper(RoomFinder);

  function RoomFinder() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, RoomFinder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "backNavigationEvent", function (e) {
      e && e.preventDefault();

      _this.props.leaveRoomSelection(_this.context);
    });

    return _this;
  }

  Object(createClass["a" /* default */])(RoomFinder, [{
    key: "renderFloorAccordion",
    value: function renderFloorAccordion() {
      var _this2 = this;

      var _this$props = this.props,
          filteredFloors = _this$props.filteredFloors,
          selectedFloorId = _this$props.selectedFloorId,
          filteredRooms = _this$props.filteredRooms,
          selectFloor = _this$props.selectFloor,
          selectRoom = _this$props.selectRoom,
          highlightRoom = _this$props.highlightRoom,
          fidelityStatus = _this$props.fidelityStatus;
      return RoomFinder_jsx("div", {
        className: "RoomFinder"
      }, (filteredFloors || []).map(function (floor) {
        return RoomFinder_jsx(accordion_PYRAccordion, {
          key: "floor".concat(floor.id),
          floor: floor,
          selected: selectedFloorId === floor.id,
          rooms: filteredRooms.filter(function (room) {
            return room.properties.floor_id === floor.id;
          }),
          onTitleClick: selectFloor,
          onItemClick: function onItemClick(roomId) {
            Room_tracking_trackRoomSelection({
              fidelityStatus: fidelityStatus,
              isQuickLogged: _this2.context.isUserQuickLogged,
              context: _this2.context
            });
            return selectRoom(roomId, _this2.context);
          },
          onItemHover: highlightRoom
        });
      }));
    }
  }, {
    key: "renderBuildingsList",
    value: function renderBuildingsList() {
      var _this$props2 = this.props,
          filteredBuildings = _this$props2.filteredBuildings,
          selectBuilding = _this$props2.selectBuilding,
          highlightBuilding = _this$props2.highlightBuilding,
          highlightedBuildingId = _this$props2.highlightedBuildingId;
      return RoomFinder_jsx("div", {
        className: "RoomFinder",
        onMouseLeave: function onMouseLeave() {
          return highlightBuilding();
        }
      }, (filteredBuildings || []).map(function (building) {
        return RoomFinder_jsx("div", {
          key: "building".concat(building.id),
          "data-selector": "SelectBuilding-Button",
          onClick: function onClick() {
            return selectBuilding(building.id);
          },
          onMouseEnter: function onMouseEnter() {
            return highlightBuilding(building.id);
          },
          className: "PYRAccordion-item"
        }, RoomFinder_jsx("div", {
          className: "PYRAccordion-item-title"
        }, RoomFinder_jsx("span", {
          className: classnames_default()('RoomFinder-building', {
            'RoomFinder-building--hover': building.id === highlightedBuildingId
          })
        }, building.label)));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          cmsContent = _this$props3.cmsContent,
          filteredBuildings = _this$props3.filteredBuildings,
          filteredFloors = _this$props3.filteredFloors,
          filteredRooms = _this$props3.filteredRooms,
          selectedBuildingId = _this$props3.selectedBuildingId;
      var classNames = ['RoomFinder-container'];

      if (selectedBuildingId !== null) {
        classNames.push('RoomFinder-container--secondStep');
      }

      var content = Object(lodash["isEmpty"])(filteredBuildings) && Object(lodash["isEmpty"])(filteredFloors) && Object(lodash["isEmpty"])(filteredRooms) ? RoomFinder_jsx("div", null, RoomFinder_jsx(Text["a" /* Text */], {
        className: "p-px15",
        text: Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.errors.noGeoJsonRoom.title', 'Sorry, no room found')
      })) : RoomFinder_jsx("div", {
        className: classNames.join(' ')
      }, this.renderBuildingsList(), this.renderFloorAccordion());
      return RoomFinder_jsx("div", null, content, RoomFinder_jsx("div", {
        className: "sidebar-footer"
      }, RoomFinder_jsx(TextLink["a" /* TextLink */], {
        label: Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.backNavigation'),
        onClick: this.backNavigationEvent,
        iconRightName: null,
        iconLeftName: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
      })));
    }
  }]);

  return RoomFinder;
}(react_default.a.Component);

Object(defineProperty["a" /* default */])(RoomFinder_RoomFinder, "contextType", ReactAppContext["a" /* default */]);

/* harmony default export */ var room_finder_RoomFinder = (RoomFinder_RoomFinder);
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/room-finder/RoomFinder.container.js





var RoomFinder_container_mapStateToProps = function mapStateToProps(_ref) {
  var _ref$pickYourRoom = _ref.pickYourRoom,
      app = _ref$pickYourRoom.app,
      mapper = _ref$pickYourRoom.mapper;
  return {
    selectedBuildingId: app.selectedBuildingId,
    filteredBuildings: app.filteredBuildings,
    selectedFloorId: app.selectedFloorId,
    filteredFloors: app.filteredFloors,
    filteredRooms: app.filteredRooms,
    highlightedBuildingId: mapper.highlightedBuildingId
  };
};

var RoomFinder_container_mapDispatchToProps = {
  leaveRoomSelection: pickYourRoom_actions["d" /* leaveRoomSelection */],
  selectBuilding: pickYourRoom_actions["e" /* selectBuilding */],
  highlightBuilding: map_actions["c" /* highlightBuilding */],
  selectFloor: pickYourRoom_actions["f" /* selectFloor */],
  selectRoom: pickYourRoom_actions["g" /* selectRoom */],
  highlightRoom: pickYourRoom_actions["b" /* highlightRoom */]
};
/* harmony default export */ var RoomFinder_container = (Object(es["c" /* connect */])(RoomFinder_container_mapStateToProps, RoomFinder_container_mapDispatchToProps)(room_finder_RoomFinder));
// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsive_responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/sidebar-header/SidebarHeader.jsx
var SidebarHeader_jsx = react_default.a.createElement;






var SidebarHeader_SidebarHeader = function SidebarHeader(_ref) {
  var onClick = _ref.onClick,
      handleTouchStart = _ref.handleTouchStart,
      handleTouchMove = _ref.handleTouchMove,
      handleTouchEnd = _ref.handleTouchEnd,
      mediaServerUrl = _ref.mediaServerUrl,
      currentRoomLabel = _ref.currentRoomLabel,
      title = _ref.title,
      closedOnMobile = _ref.closedOnMobile;
  var responsiveContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);
  var isBrowserGreaterThanS = Object(lodash["get"])(responsiveContext, 'isBrowserGreaterThan.S');
  return isBrowserGreaterThanS ? SidebarHeader_jsx("div", {
    className: "sidebar-header",
    onClick: onClick,
    onTouchStart: function onTouchStart(touchStartEvent) {
      return handleTouchStart(touchStartEvent);
    },
    onTouchMove: function onTouchMove(touchMouveEvent) {
      return handleTouchMove(touchMouveEvent);
    },
    onTouchEnd: function onTouchEnd() {
      return handleTouchEnd();
    },
    style: {
      backgroundImage: "url(".concat(mediaServerUrl, ")")
    }
  }, SidebarHeader_jsx("p", {
    className: "sidebar-header-progress"
  }, currentRoomLabel), SidebarHeader_jsx("p", {
    className: "sidebar-header-title font-brand"
  }, title)) : SidebarHeader_jsx("div", {
    className: "flex justify-between sidebar-header",
    onClick: onClick,
    onTouchStart: function onTouchStart(touchStartEvent) {
      return handleTouchStart(touchStartEvent);
    },
    onTouchMove: function onTouchMove(touchMouveEvent) {
      return handleTouchMove(touchMouveEvent);
    },
    onTouchEnd: function onTouchEnd() {
      return handleTouchEnd();
    }
  }, SidebarHeader_jsx("section", null, SidebarHeader_jsx("p", null, currentRoomLabel), SidebarHeader_jsx("span", {
    className: "font-brand text-black text-4xl"
  }, title)), SidebarHeader_jsx("aside", {
    className: "flex flex-col justify-center"
  }, SidebarHeader_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_FORTH,
    rotation: closedOnMobile ? -90 : 90,
    color: colors["a" /* COLORS */].BLUE,
    width: "1rem"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/Sidebar.jsx







var Sidebar_jsx = react_default.a.createElement;

function Sidebar_createSuper(Derived) { var hasNativeReflectConstruct = Sidebar_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Sidebar_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









function getNumRoomLeftToPickText(cmsContent, numRoomsLeftToPick) {
  switch (numRoomsLeftToPick) {
    case 0:
      return Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.allRoomsPicked');

    case 1:
      return Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.oneRoomLeftToPick');

    default:
      {
        return Object(dist["messageFormat"])(Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.severalRoomsLeftToPick')).format({
          numRooms: numRoomsLeftToPick
        });
      }
  }
}

var Sidebar_Sidebar = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(Sidebar, _React$Component);

  var _super = Sidebar_createSuper(Sidebar);

  function Sidebar() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Sidebar);

    _this = _super.call(this);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClick", function () {
      _this.setState({
        closedOnMobile: !_this.state.closedOnMobile
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleTouchStart", function (event) {
      _this.setState({
        headerTouchStart: event.touches[0]
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleTouchMove", function (event) {
      _this.setState({
        headerTouchLastMove: event.touches[0]
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleTouchEnd", function () {
      if (_this.state.headerTouchStart && _this.state.headerTouchLastMove) {
        _this.setState({
          headerTouchStart: null,
          headerTouchLastMove: null,
          closedOnMobile: // $FlowFixMe clientY is normally defined in EventTarget
          _this.state.headerTouchLastMove.clientY > _this.state.headerTouchStart.clientY
        });
      }

      _this.setState({
        headerTouchStart: null,
        headerTouchLastMove: null
      });
    });

    _this.state = {
      headerTouchStart: null,
      headerTouchLastMove: null,
      closedOnMobile: true
    };
    return _this;
  }

  Object(createClass["a" /* default */])(Sidebar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          completedIntro = _this$props.completedIntro,
          selectedBuildingId = _this$props.selectedBuildingId,
          currentSelectedRoomIndex = _this$props.currentSelectedRoomIndex,
          numSelectableRooms = _this$props.numSelectableRooms,
          numRoomsLeftToPick = _this$props.numRoomsLeftToPick,
          cmsContent = _this$props.cmsContent,
          resortImage = _this$props.resortImage,
          stayId = _this$props.stayId,
          fidelityStatus = _this$props.fidelityStatus;

      if (!cmsContent) {
        return null;
      }

      var numRoomLeftToPickText = getNumRoomLeftToPickText(cmsContent, numRoomsLeftToPick);
      var containerClassNames = ['Sidebar'];
      var roomFinderClassNames = [];

      if (currentSelectedRoomIndex === null) {
        containerClassNames.push(completedIntro === false ? 'Sidebar--closedOnMobile' : 'Sidebar--full-screen');
        roomFinderClassNames = containerClassNames.concat(['Sidebar--hiddenStep']);
      } else {
        containerClassNames.push(this.state.closedOnMobile === true ? 'Sidebar--closedOnMobile' : 'Sidebar--default');
        roomFinderClassNames = containerClassNames;
      }

      var title = selectedBuildingId === null ? Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.selectBuilding') : Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.selectRoom');
      var currentRoomLabel = Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.currentRoom') ? Object(dist["messageFormat"])(Object(lodash["get"])(cmsContent, 'memberSpace.pickYourRoom.currentRoom')).format({
        currentSelectedRoom: "".concat(currentSelectedRoomIndex + 1),
        numSelectableRooms: "".concat(numSelectableRooms)
      }) : null;
      var mediaServerUrl = resortImage ? Object(heroUtils["e" /* getBackgroundImageUrl */])(resortImage, 400) : '';
      return Sidebar_jsx("div", {
        className: "Sidebar-wrapper"
      }, Sidebar_jsx("div", {
        className: containerClassNames.join(' ')
      }, Sidebar_jsx("div", {
        className: "sidebar-content"
      }, numRoomsLeftToPick !== null && Sidebar_jsx("p", {
        className: "sidebar-content-title font-brand"
      }, numRoomLeftToPickText), Sidebar_jsx(RoomSelector_container, {
        cmsContent: cmsContent,
        stayId: stayId
      }))), Sidebar_jsx("div", {
        className: roomFinderClassNames.join(' ')
      }, Sidebar_jsx(SidebarHeader_SidebarHeader, {
        onClick: this.onClick,
        handleTouchStart: this.handleTouchStart,
        handleTouchMove: this.handleTouchMove,
        handleTouchEnd: this.handleTouchEnd,
        mediaServerUrl: mediaServerUrl,
        currentRoomLabel: currentRoomLabel,
        title: title,
        closedOnMobile: this.state.closedOnMobile
      }), Sidebar_jsx("div", {
        className: "sidebar-content"
      }, Sidebar_jsx(RoomFinder_container, {
        cmsContent: cmsContent,
        fidelityStatus: fidelityStatus || null
      }))));
    }
  }]);

  return Sidebar;
}(react_default.a.Component);

/* harmony default export */ var sidebar_Sidebar = (Sidebar_Sidebar);
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/sidebar/Sidebar.container.js



var Sidebar_container_mapStateToProps = function mapStateToProps(_ref) {
  var app = _ref.pickYourRoom.app;
  return {
    completedIntro: app.completedIntro,
    selectedBuildingId: app.selectedBuildingId,
    numSelectableRooms: (app.selectableRooms || []).length,
    numRoomsLeftToPick: app.numRoomsLeftToPick,
    currentSelectedRoomIndex: app.currentSelectedRoomIndex,
    fidelityStatus: app.fidelityStatus
  };
};

var SidebarContainer = Object(es["c" /* connect */])(Sidebar_container_mapStateToProps)(sidebar_Sidebar);
// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/PickYourRoomWrapper.tracking.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




function trackingPageLoad(_ref) {
  var fidelityStatus = _ref.fidelityStatus,
      isQuickLogged = _ref.isQuickLogged,
      context = _ref.context;
  var categoryGA = Object(utils["a" /* getPLECategoryGA */])(isQuickLogged);
  tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    pageName: "".concat(categoryGA, "_pickYourRoom"),
    siteSection: categoryGA,
    fidelityStatus: fidelityStatus
  }), context);
}
// EXTERNAL MODULE: ./src/client/components/frameworks/skeleton/Skeleton.jsx + 1 modules
var Skeleton = __webpack_require__("pT/1");

// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/PickYourRoomSkeleton.jsx
var PickYourRoomSkeleton_jsx = react_default.a.createElement;


var PickYourRoomSkeleton_PickYourRoomSkeleton = function PickYourRoomSkeleton() {
  return PickYourRoomSkeleton_jsx("div", {
    className: "flex h-full w-full"
  }, PickYourRoomSkeleton_jsx(Skeleton["a" /* default */], {
    isLoading: true,
    className: "flex-1"
  }), PickYourRoomSkeleton_jsx("div", {
    className: "flex flex-col h-full",
    style: {
      width: '25rem'
    }
  }, PickYourRoomSkeleton_jsx(Skeleton["a" /* default */], {
    isLoading: true,
    className: "mx-px15 mb-px20"
  }, PickYourRoomSkeleton_jsx("div", {
    style: {
      height: '4rem'
    }
  })), PickYourRoomSkeleton_jsx(Skeleton["a" /* default */], {
    isLoading: true,
    className: "mx-px15"
  }, PickYourRoomSkeleton_jsx("div", {
    style: {
      height: '16rem'
    }
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/PickYourRoomWrapper.jsx
var PickYourRoomWrapper_jsx = react_default.a.createElement;












var PickYourRoomWrapper_renderError = function renderError(_ref, cmsContent, resortPYRMail) {
  var type = _ref.type;
  return PickYourRoomWrapper_jsx("div", {
    className: "PickYourRoom-wrapper-error"
  }, PickYourRoomWrapper_jsx(Title["a" /* Title */], {
    hLevel: 2,
    theme: "title-brand-11"
  }, Object(lodash["get"])(cmsContent, "memberSpace.pickYourRoom.errors.".concat(type, ".title"))), PickYourRoomWrapper_jsx(Title["a" /* Title */], {
    hLevel: 3,
    theme: "title-sans-11"
  }, Object(lodash["get"])(cmsContent, "memberSpace.pickYourRoom.errors.".concat(type, ".subtitle"), '').replace('{ResortPYRMail}', resortPYRMail)));
};

function PickYourRoomWrapper(props) {
  var loadPickYourRoom = props.loadPickYourRoom,
      stayWithVendor = props.stayWithVendor,
      fidelityStatus = props.fidelityStatus,
      isLoading = props.isLoading,
      error = props.error,
      cmsContent = props.cmsContent,
      geoJSONLoaded = props.geoJSONLoaded,
      stayId = props.stayId,
      resortPYRMail = props.resortPYRMail,
      dataTestId = props.dataTestId;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isQuickLogged = _useAuthentication.isQuickLogged;

  Object(react["useEffect"])(function () {
    loadPickYourRoom(stayWithVendor, appContext);
    trackingPageLoad({
      fidelityStatus: fidelityStatus,
      isQuickLogged: isQuickLogged,
      context: appContext
    });
  }, [stayWithVendor]);
  var cart = Object(lodash["get"])(Object(es["e" /* useSelector */])(function (state) {
    return state.memberSpace.bookingCart;
  }), 'data.userBooking.cart', {});
  if (isLoading) return PickYourRoomWrapper_jsx(PickYourRoomSkeleton_PickYourRoomSkeleton, null);

  if (error) {
    return PickYourRoomWrapper_renderError(error, cmsContent, resortPYRMail);
  }

  return PickYourRoomWrapper_jsx("div", {
    className: classnames_default()('PickYourRoom-wrapper', {
      'mb-px80': cart.isEmpty === false
    }),
    "data-testid": dataTestId
  }, geoJSONLoaded ? PickYourRoomWrapper_jsx("div", {
    className: "PickYourRoom-wrapper--Map"
  }, PickYourRoomWrapper_jsx(Map_container, {
    cmsContent: cmsContent
  })) : null, PickYourRoomWrapper_jsx(SidebarContainer, {
    resortImage: Object(lodash["get"])(stayWithVendor, 'resort.image'),
    cmsContent: cmsContent,
    stayId: stayId
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/pick-your-room/wrapper/PickYourRoomWrapper.container.js





var PickYourRoomWrapper_container_geoJSONSelector = function geoJSONSelector(state) {
  return Object(lodash["get"])(state, 'pickYourRoom.mapper.geoJSON');
};

var PickYourRoomWrapper_container_noRoomToSelectError = function noRoomToSelectError(state) {
  return Object(lodash["isEmpty"])(Object(lodash["get"])(state, 'pickYourRoom.app.selectableRooms')) && Object(lodash["isEmpty"])(Object(lodash["get"])(state, 'pickYourRoom.app.selectedRooms')) ? {
    type: 'noRoom',
    reason: 'No room available'
  } : null;
};

var PickYourRoomWrapper_container_pickYourRoomError = function pickYourRoomError(state) {
  if (!PickYourRoomWrapper_container_geoJSONSelector(state)) return null;

  switch (Object(lodash["get"])(state, 'pickYourRoom.app.errors')) {
    case 400:
      return {
        type: 'notEligible',
        reason: 'not eligible error'
      };

    case 404:
      return {
        type: 'invalidFileNumber',
        reason: 'booking not found'
      };

    default:
      return PickYourRoomWrapper_container_noRoomToSelectError(state);
  }
};

var PickYourRoomWrapper_container_mapperError = function mapperError(state) {
  return Object(lodash["get"])(state, 'pickYourRoom.mapper.error') ? {
    type: 'unhandled',
    reason: 'mapper error'
  } : null;
};

var PickYourRoomWrapper_container_mapStateToProps = function mapStateToProps(state) {
  return {
    isLoading: Object(lodash["get"])(state, 'pickYourRoom.app.isLoadingResort') || Object(lodash["get"])(state, 'pickYourRoom.app.isLoadingSelectableRooms'),
    geoJSONLoaded: !!PickYourRoomWrapper_container_geoJSONSelector(state),
    error: PickYourRoomWrapper_container_mapperError(state) || PickYourRoomWrapper_container_pickYourRoomError(state),
    resortPYRMail: Object(lodash["get"])(state, 'pickYourRoom.app.resortPYRMail')
  };
};

var PickYourRoomWrapper_container_mapDispatchToProps = {
  loadPickYourRoom: map_actions["d" /* loadPickYourRoom */]
};
var PickYourRoomWrapperContainer = Object(es["c" /* connect */])(PickYourRoomWrapper_container_mapStateToProps, PickYourRoomWrapper_container_mapDispatchToProps)(PickYourRoomWrapper);

/***/ }),

/***/ "Onl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockLink; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("NJJ8");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");
/* harmony import */ var _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uRnh");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var BlockLink = /*#__PURE__*/function (_PureComponent) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(BlockLink, _PureComponent);

  var _super = _createSuper(BlockLink);

  function BlockLink() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, BlockLink);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(BlockLink, [{
    key: "renderTexts",
    value: function renderTexts() {
      var texts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$props$theme = this.props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme;
      return texts.filter(function (text) {
        return !Object(lodash__WEBPACK_IMPORTED_MODULE_6__["isEmpty"])(text);
      }).map(function (text, idx) {
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(classes, _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__[/* themes */ "a"][theme]["thCustomText".concat(idx)]),
          "data-testid": "BlockLink-text",
          key: idx
        }, text);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          icon = _this$props.icon,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === void 0 ? function () {} : _this$props$onClick,
          _this$props$secondary = _this$props.secondaryTexts,
          secondaryTexts = _this$props$secondary === void 0 ? [] : _this$props$secondary,
          _this$props$target = _this$props.target,
          target = _this$props$target === void 0 ? '_blank' : _this$props$target,
          _this$props$texts = _this$props.texts,
          texts = _this$props$texts === void 0 ? [] : _this$props$texts,
          _this$props$theme2 = _this$props.theme,
          theme = _this$props$theme2 === void 0 ? 'default' : _this$props$theme2,
          trackingData = _this$props.trackingData,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '' : _this$props$url;
      var title = (texts || []).filter(function (t) {
        return typeof t === 'string';
      }).join(' ');
      var linkTarget = url.startsWith('tel:') ? '' : target;
      var _themes$theme = _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__[/* themes */ "a"][theme],
          thIcon = _themes$theme.thIcon,
          thIconWidth = _themes$theme.thIconWidth,
          thRoot = _themes$theme.thRoot,
          thTexts = _themes$theme.thTexts,
          thSText = _themes$theme.thSText;
      return !!texts.length || icon ? __jsx(_tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_8__[/* TrackClick */ "a"], {
        as: "a",
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, thRoot),
        href: url,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: linkTarget,
        title: title,
        trackingData: trackingData
      }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('flex-shrink-0', thIcon),
        name: icon,
        width: thIconWidth
      }), !!texts.length && __jsx("span", {
        className: thTexts
      }, this.renderTexts(texts), this.renderTexts(secondaryTexts, thSText))) : null;
    }
  }]);

  return BlockLink;
}(react__WEBPACK_IMPORTED_MODULE_5__["PureComponent"]);

/***/ }),

/***/ "XHSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export savePaymentTrackingDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPaymentTrackingDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeBuildPrePaymentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildPrePaymentUrlAndRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFormData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extractPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDevice; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O2W8");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lz_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("U2CP");
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("6jSF");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("CcNa");
/* harmony import */ var _PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("19WB");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












function initPayment(payload, appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].runNoCacheQuery(Object(_PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__[/* getInitPaymentQuery */ "b"])(payload), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_INIT */ "Zc"]
  }).then(function (_ref) {
    var prePayment = _ref.prePayment;
    return prePayment || {};
  });
}

function buildPrePaymentUrl() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var locale = arguments.length > 1 ? arguments[1] : undefined;
  var t = payload ? lz_string__WEBPACK_IMPORTED_MODULE_2___default.a.compressToEncodedURIComponent(JSON.stringify(payload)) : '';
  var query = {
    t: t,
    locale: locale
  };
  return new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(_routes_routeBuilder__WEBPACK_IMPORTED_MODULE_6__[/* urlPattern */ "b"]('prePayment')).query(query).toString();
}

function savePaymentTrackingDatas(orderId, values) {
  js_cookie__WEBPACK_IMPORTED_MODULE_3___default.a.set('PRE_PAYMENT_INFOS-' + orderId, _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["oidc"].toUriEncodedState(values));
}
function getPaymentTrackingDatas(orderId) {
  var value = js_cookie__WEBPACK_IMPORTED_MODULE_3___default.a.get("PRE_PAYMENT_INFOS-".concat(orderId));
  return value ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["oidc"].fromUriEncodedState(value) : null;
}
function makeBuildPrePaymentUrl(appContext) {
  return function createPrePaymentUrl() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return initPayment(params, appContext).then(function (datas) {
      var payload = _objectSpread(_objectSpread({}, params), datas);

      if (params.urlRedirectionIfNothingToPay && datas.amount === 0) {
        if (params.beforeRedirect) {
          params.beforeRedirect();
        }

        return params.urlRedirectionIfNothingToPay;
      }

      return buildPrePaymentUrl(payload, Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale'));
    });
  };
}
function buildPrePaymentUrlAndRedirect(_ref2) {
  var appContext = _ref2.appContext,
      history = _ref2.history,
      location = _ref2.location,
      _ref2$payload = _ref2.payload,
      payload = _ref2$payload === void 0 ? {} : _ref2$payload,
      _ref2$isFreeDeposit = _ref2.isFreeDeposit,
      isFreeDeposit = _ref2$isFreeDeposit === void 0 ? false : _ref2$isFreeDeposit;
  return makeBuildPrePaymentUrl(appContext)(payload).then(function (url) {
    history.pushRoute(isFreeDeposit ? new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(url).addQuery('freedeposit').toString() : url);
  })["catch"](function (err) {
    if (_utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* hasAuthResponseError */ "l"](err)) {
      _utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* redirectOnLoginPage */ "o"]({
        locale: appContext.locale,
        redirectPath: location.pathname
      });
      return;
    }

    if (_utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* hasNotFoundError */ "m"](err)) {
      _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation('/404');
      return;
    }

    throw err;
  });
}
function getFormData(params, appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].runNoCacheQuery(Object(_PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__[/* getFormDataQuery */ "a"])(params), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_PRE_GET_FORM_DATA */ "dd"]
  });
}
function extractPayload(payload) {
  if (!payload) {
    return null;
  }

  var value = null;

  try {
    value = lz_string__WEBPACK_IMPORTED_MODULE_2___default.a.decompressFromEncodedURIComponent(payload);
    return JSON.parse(value);
  } catch (e) {
    console.error('extractPayload', e, ' for value:', value); // eslint-disable-line no-console

    return null;
  }
}
function getDevice(responsive) {
  if (responsive.isDesktop) return 'DESKTOP';
  if (responsive.isTablet) return 'TABLET';
  return 'MOBILE';
}

/***/ }),

/***/ "blgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_STATUS_ARCHIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_STATUS_VALIDATED; });
/* unused harmony export BOOKING_STATUS_CANCELED */
/* unused harmony export BOOKING_STATUS_QUOTATION */
/* unused harmony export BOOKING_STATUS_HOPE */
/* unused harmony export BOOKING_STATUS_EXPIRED_OPTION */
/* unused harmony export BOOKING_STATUS_EXPIRED_HOPE */
/* unused harmony export BOOKING_STATUS_EXPIRED_QUOTATION */
/* unused harmony export BOOKING_STATUS_REQUEST */
var BOOKING_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_STATUS_CANCELED = 'CANCELED';
var BOOKING_STATUS_QUOTATION = 'QUOTATION';
var BOOKING_STATUS_HOPE = 'HOPE';
var BOOKING_STATUS_EXPIRED_OPTION = 'EXPIRED_OPTION';
var BOOKING_STATUS_EXPIRED_HOPE = 'EXPIRED_HOPE';
var BOOKING_STATUS_EXPIRED_QUOTATION = 'EXPIRED_QUOTATION';
var BOOKING_STATUS_REQUEST = 'REQUEST';
var BOOKING_STATUS_ARCHIVED = 'ARCHIVED';


/***/ }),

/***/ "fYnN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "ggkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapContextToProps; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Ub5k");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



function mapContextToProps() {
  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  return function (Component) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_React$Component) {
      Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(MapContextToProps, _React$Component);

      var _super = _createSuper(MapContextToProps);

      function MapContextToProps() {
        Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(this, MapContextToProps);

        return _super.apply(this, arguments);
      }

      Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(MapContextToProps, [{
        key: "render",
        value: function render() {
          return __jsx(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, this.props, fn(this.context)));
        }
      }]);

      return MapContextToProps;
    }(react__WEBPACK_IMPORTED_MODULE_7___default.a.Component), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_class, "displayName", "MapContextToProps(".concat(Component.displayName || 'Unknown', ")")), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_class, "contextType", _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]), _temp;
  };
}

/***/ }),

/***/ "j80U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackPYRResortOnlyRequest; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d1HQ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


function trackPYRResortOnlyRequest(params, context) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_1__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, params), {}, {
    actionGA: 'pickYourRoom',
    labelGA: 'ResortOnly_validateForm'
  }), context);
}

/***/ }),

/***/ "jD8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TextLink_TextLink; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.themes.js

var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color;
    return {
      thIconWidth: '.7em',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-base focus:underline hover:underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  fancy: function fancy(_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color;
    return {
      thIconWidth: '0.4375rem',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-sm"),
      thLabel: '',
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  solid: function solid(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref3$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " bg-current font-bold font-sans leading-one p-px10 rounded-tiny text-base uppercase"),
      thLabel: 'text-white',
      thIconLeft: 'text-white rtl:mr-px10',
      thIconRight: 'text-white rtl:ml-px10'
    };
  },
  simple: function simple(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref4$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " font-sans leading-loose self-start text-base underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx

var __jsx = react_default.a.createElement;







var TextLink_TextLink = function TextLink(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      color = _ref.color,
      iconLeftName = _ref.iconLeftName,
      _ref$iconRightName = _ref.iconRightName,
      iconRightName = _ref$iconRightName === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH : _ref$iconRightName,
      isExternalLink = _ref.isExternalLink,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      target = _ref.target,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData,
      url = _ref.url;

  if (!label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color
  }),
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    as: url ? DynamicLink["a" /* default */] : 'button',
    className: classnames_default()(className, 'reset-button inline-flex items-center', thRoot),
    onClick: onClick,
    tabIndex: tabIndex,
    target: target,
    trackingData: trackingData
  }, url ? {
    url: url,
    isExternalLink: isExternalLink
  } : {
    type: 'button'
  }), !!iconLeftName && __jsx(Icon["a" /* Icon */], {
    className: thIconLeft,
    hasRtl: true,
    name: iconLeftName,
    width: thIconWidth
  }), __jsx("span", {
    className: thLabel
  }, label), !!iconRightName && __jsx(Icon["a" /* Icon */], {
    className: thIconRight,
    hasRtl: true,
    name: iconRightName,
    width: thIconWidth
  }));
};

/***/ }),

/***/ "kD/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_BOOKING_CART; });
/* unused harmony export getBookingCartQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookingCart; });
/* unused harmony export removeService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateBookingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateBookingCartSequencially; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateBookingCartAll; });
/* harmony import */ var _store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Nhxn");




var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';
var cartQuery = "\n    cart {\n        childcares {\n            id\n            productId\n            label\n            type\n            attendees {\n                id\n                price\n            }\n            startDate\n            endDate\n            schedules {\n              startDate\n              endDate\n              attendees {\n                id\n                price\n              }\n            }\n        }\n        transfers {\n          id\n          productId\n          type\n          label\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        insurance {\n          id\n          productId\n          type\n          label\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        rentals {\n          id\n          productId\n          type\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n          attendees {\n            id\n            schedules {\n              price {\n                value\n              }\n              startDate\n              endDate\n            }\n          }\n        }\n        activities {\n          id\n          productId\n          type\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        pickRoom { \n          id\n          type\n          accommodations {\n            id \n            rooms {\n              id\n            }\n          }\n        }\n        price {\n            total {\n                formattedValue(precision: 2)\n                value\n                currency\n            }\n            currency\n            detail {\n              service\n              amount\n            }\n        }\n        isEmpty\n    }\n";
var getBookingCartQuery = function getBookingCartQuery(bookingId) {
  return "query {\n        userBooking(bookingId : \"".concat(bookingId, "\") {\n          ").concat(cartQuery, "\n        }\n    }");
};
var fetchBookingCart = function fetchBookingCart(stay, context) {
  return function (dispatch) {
    return dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(FETCH_BOOKING_CART, {
      stay: stay
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(getBookingCartQuery(stay.bookingId), context, {
        requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_GET_BOOKING_CART */ "h"]
      })
    }));
  };
};

var addService = function addService(_ref) {
  var id = _ref.id,
      bookingId = _ref.bookingId,
      schedules = _ref.schedules,
      accommodations = _ref.accommodations,
      serviceName = _ref.serviceName;
  return "mutation {\n            addServiceCart(\n             bookingId : \"".concat(bookingId, "\",\n             serviceCart: {\n                 id: \"").concat(id, "\",\n                 ").concat(schedules ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__[/* attributesToString */ "a"])({
    schedules: schedules
  }) : '', "\n                 ").concat(accommodations ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__[/* attributesToString */ "a"])({
    accommodations: accommodations
  }) : '', "\n             }\n             serviceName: \"").concat(serviceName, "\") {\n                ").concat(cartQuery, "\n             }\n          }");
};

var removeService = function removeService(id, bookingId) {
  return "mutation {\n              removeServiceCart(\n               bookingId : \"".concat(bookingId, "\",\n               itemId: \"").concat(id, "\")\n               {\n                ").concat(cartQuery, "\n               }\n            }");
};
var updateBookingCart = function updateBookingCart(_ref2) {
  var id = _ref2.id,
      bookingId = _ref2.bookingId,
      schedules = _ref2.schedules,
      accommodations = _ref2.accommodations,
      serviceName = _ref2.serviceName,
      context = _ref2.context,
      action = _ref2.action,
      successMsg = _ref2.successMsg;
  return function (dispatch) {
    dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(UPDATE_BOOKING_CART, {
      id: id,
      toastLabel: successMsg
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
        id: id,
        bookingId: bookingId,
        schedules: schedules,
        accommodations: accommodations,
        serviceName: serviceName
      }) : removeService(id, bookingId), context, {
        requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
      })
    }));
  };
};
var updateBookingCartSequencially = function updateBookingCartSequencially(params) {
  if (params.length === 0) {
    return Promise.resolve();
  }

  var _params$ = params[0],
      id = _params$.id,
      bookingId = _params$.bookingId,
      schedules = _params$.schedules,
      accommodations = _params$.accommodations,
      serviceName = _params$.serviceName,
      context = _params$.context,
      action = _params$.action;
  var promise = _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
    id: id,
    bookingId: bookingId,
    schedules: schedules,
    accommodations: accommodations,
    serviceName: serviceName
  }) : removeService(id, bookingId), context, {
    requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
  });
  return promise.then(function () {
    return updateBookingCartSequencially(params.slice(1));
  });
};
var updateBookingCartAll = function updateBookingCartAll(params) {
  return Promise.all(params.map(function (_ref3) {
    var id = _ref3.id,
        bookingId = _ref3.bookingId,
        schedules = _ref3.schedules,
        accommodations = _ref3.accommodations,
        serviceName = _ref3.serviceName,
        context = _ref3.context,
        action = _ref3.action;
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
      id: id,
      bookingId: bookingId,
      schedules: schedules,
      accommodations: accommodations,
      serviceName: serviceName
    }) : removeService(id, bookingId), context, {
      requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
    });
  }));
};

/***/ }),

/***/ "pPFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isRegexp = __webpack_require__("1dAi");
var isPlainObj = __webpack_require__("I8qj");

module.exports = function (val, opts, pad) {
	var seen = [];

	return (function stringify(val, opts, pad) {
		opts = opts || {};
		opts.indent = opts.indent || '\t';
		pad = pad || '';
		var tokens;
		if(opts.inlineCharacterLimit == void 0) {
			tokens = {
				newLine: '\n',
				newLineOrSpace: '\n',
				pad: pad,
				indent: pad + opts.indent
			};
		} else {
			tokens = {
				newLine: '@@__STRINGIFY_OBJECT_NEW_LINE__@@',
				newLineOrSpace: '@@__STRINGIFY_OBJECT_NEW_LINE_OR_SPACE__@@',
				pad: '@@__STRINGIFY_OBJECT_PAD__@@',
				indent: '@@__STRINGIFY_OBJECT_INDENT__@@'
			}
		}
		var expandWhiteSpace = function(string) {
			if (opts.inlineCharacterLimit == void 0) { return string; }
			var oneLined = string.
				replace(new RegExp(tokens.newLine, 'g'), '').
				replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').
				replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');

			if(oneLined.length <= opts.inlineCharacterLimit) {
				return oneLined;
			} else {
				return string.
					replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').
					replace(new RegExp(tokens.pad, 'g'), pad).
					replace(new RegExp(tokens.indent, 'g'), pad + opts.indent);
			}
		};

		if (seen.indexOf(val) !== -1) {
			return '"[Circular]"';
		}

		if (val === null ||
			val === undefined ||
			typeof val === 'number' ||
			typeof val === 'boolean' ||
			typeof val === 'function' ||
			isRegexp(val)) {
			return String(val);
		}

		if (val instanceof Date) {
			return 'new Date(\'' + val.toISOString() + '\')';
		}

		if (Array.isArray(val)) {
			if (val.length === 0) {
				return '[]';
			}

			seen.push(val);

			var ret = '[' + tokens.newLine + val.map(function (el, i) {
				var eol = val.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
				return tokens.indent + stringify(el, opts, pad + opts.indent) + eol;
			}).join('') + tokens.pad + ']';

			seen.pop(val);

			return expandWhiteSpace(ret);
		}

		if (isPlainObj(val)) {
			var objKeys = Object.keys(val);

			if (objKeys.length === 0) {
				return '{}';
			}

			seen.push(val);

			var ret = '{' + tokens.newLine + objKeys.map(function (el, i) {
				if (opts.filter && !opts.filter(val, el)) {
					return '';
				}

				var eol = objKeys.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
				var key = /^[a-z$_][a-z$_0-9]*$/i.test(el) ? el : stringify(el, opts);
				return tokens.indent + key + ': ' + stringify(val[el], opts, pad + opts.indent) + eol;
			}).join('') + tokens.pad + '}';

			seen.pop(val);

			return expandWhiteSpace(ret);
		}

		val = String(val).replace(/[\r\n]/g, function (x) {
			return x === '\n' ? '\\n' : '\\r';
		});

		if (opts.singleQuotes === false) {
			return '"' + val.replace(/"/g, '\\\"') + '"';
		}

		return '\'' + val.replace(/'/g, '\\\'') + '\'';
	})(val, opts, pad);
};


/***/ }),

/***/ "pT/1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/skeleton/Skeleton.themes.js
/* harmony default export */ var Skeleton_themes = ({
  none: {
    loading: {
      container: 'Skeleton-default-bg Skeleton-default-animation',
      content: 'opacity-0'
    },
    loaded: {
      container: 'Skeleton-default-bg',
      content: 'fadeInLong'
    }
  },
  pulse: {
    loading: {
      container: 'Skeleton-pulse-bg Skeleton-pulse-animation',
      content: 'opacity-0'
    },
    loaded: {
      container: 'Skeleton-pulse-bg',
      content: 'fadeInLong'
    }
  }
});
// CONCATENATED MODULE: ./src/client/components/frameworks/skeleton/Skeleton.jsx
var __jsx = react_default.a.createElement;




var Skeleton_Skeleton = function Skeleton(_ref) {
  var isLoading = _ref.isLoading,
      theme = _ref.theme,
      className = _ref.className,
      children = _ref.children,
      style = _ref.style;
  var classes = (Skeleton_themes[theme] || Skeleton_themes.none)[isLoading ? 'loading' : 'loaded'];
  return __jsx("div", {
    className: classnames_default()('Skeleton-container', className, classes.container),
    style: style
  }, __jsx("div", {
    className: classnames_default()('Skeleton-content', className, classes.content)
  }, children));
};

/* harmony default export */ var skeleton_Skeleton = __webpack_exports__["a"] = (Skeleton_Skeleton);

/***/ }),

/***/ "rJ95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createOptimisticAction; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function createAction(type, payload) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}

function createOptimisticAction(type, payload, meta) {
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}


/* harmony default export */ __webpack_exports__["b"] = (createAction);

/***/ }),

/***/ "uRnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
var themes = {
  "default": {
    thRoot: 'cursor-pointer flex items-center font-bold font-sans leading-one no-underline text-sm text-white',
    thIcon: 'rtl:mr-px5',
    thIconWidth: '2.5rem',
    thSText: 'text-base uppercase',
    thCustomText1: 'text-base uppercase'
  },
  black: {
    thRoot: 'flex justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-gray-darker text-md',
    thIcon: 'text-gray-darker mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '2rem',
    thCustomText2: 'text-booking'
  },
  footerLite: {
    thRoot: 'flex flex-col lg:flex-row items-center text-center lg:text-initial text-blue',
    thIcon: 'lg:flex-shrink-0 mb-px10 lg:mb-0 lg:rtl:mr-px10',
    thIconWidth: '1.5625rem',
    thTexts: 'lg:flex-1 text-gray-darker text-base',
    thCustomText0: 'font-bold text-blue text-md',
    thCustomText1: 'font-bold text-blue text-md'
  },
  contact: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '1.75rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-light'
  },
  contact2: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '3rem',
    thCustomText1: 'font-normal text-base text-gray-light',
    thCustomText2: 'font-normal text-base text-gray-darker'
  },
  smallFooterLite: {
    thRoot: 'cursor-pointer flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md text-blue',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '1.2rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-darker'
  },
  search: {
    thRoot: 'cursor-pointer items-center font-sans no-underline text-sm text-white'
  }
};

/***/ }),

/***/ "vakO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("U2CP");
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ycRU");
/* harmony import */ var _booking_status_bookingStatus_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("blgx");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ldK3");










function formatPhoneNumber(agencyPhoneNumber) {
  return agencyPhoneNumber && "tel:".concat(agencyPhoneNumber.replace(/\s/g, ''));
}

function getPhoneNumber(vendor, fallbackPhoneNumber) {
  return vendor && (vendor.isSoldByClubMed && !vendor.phoneNumber ? fallbackPhoneNumber : vendor.phoneNumber);
}

function getAgencyLabel(vendor, cmsContent) {
  var pleaseContactClubMedLabel = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(cmsContent, 'pleaseContactClubMedLabel', null);
  var pleaseContactExternalLabel = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(cmsContent, 'pleaseContactExternalLabel', null);
  return vendor && (vendor.isSoldByClubMed ? pleaseContactClubMedLabel : pleaseContactExternalLabel && Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["messageFormat"])(pleaseContactExternalLabel).format({
    agencyName: vendor.name
  }));
}

function getAgencyDetails(_ref) {
  var vendor = _ref.vendor,
      travelAdvisor = _ref.travelAdvisor,
      dedicatedJoyviewHotlineNumber = _ref.dedicatedJoyviewHotlineNumber,
      isJoyview = _ref.isJoyview;
  var agencyPhoneNumber = isJoyview && !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(dedicatedJoyviewHotlineNumber) ? dedicatedJoyviewHotlineNumber : this.getPhoneNumber(vendor, Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(travelAdvisor, 'phoneNumber'));
  return {
    label: agencyPhoneNumber,
    url: this.formatPhoneNumber(agencyPhoneNumber)
  };
}

function isPastTrip(returnDate) {
  if (!returnDate) {
    return false;
  }

  return moment__WEBPACK_IMPORTED_MODULE_1___default()(Date.now()).isAfter(moment__WEBPACK_IMPORTED_MODULE_1___default()(returnDate, 'YYYYMMDD'));
}

function shouldDisplayPriceDetail(isSoldByClubMed, displayPriceDetail) {
  return isSoldByClubMed || displayPriceDetail;
}

function getPackageIcon(isAllInclusive, isJoyview) {
  var iconAccommodations = isJoyview ? _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].JOYVIEW_HAND : _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACCOMODATIONS;
  return isAllInclusive ? _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ALL_INCLUSIVE : iconAccommodations;
}

function isOption(informationStatus) {
  return informationStatus === _booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_6__[/* BOOKING_PAYMENT_STATUS_OPTION */ "c"];
}

function isArchived(bookingStatus) {
  return bookingStatus === _booking_status_bookingStatus_constants__WEBPACK_IMPORTED_MODULE_7__[/* BOOKING_STATUS_ARCHIVED */ "a"];
}

function shouldDisplayLinkList(userBooking) {
  var currentUri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new urijs__WEBPACK_IMPORTED_MODULE_2___default.a('#');
  var isFeatureFlippedOff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var stay = arguments.length > 3 ? arguments[3] : undefined;
  var prepareMyStayDirectory = new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(Object(_routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__[/* buildUrl */ "a"])('prepareMyStay', {
    bookingId: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(userBooking, 'information.bookingId')
  })).directory();
  var isOnPrepareMyStay = currentUri.directory() === prepareMyStayDirectory.toString();
  return !isOption(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(userBooking, 'information.status')) && !isPastTrip(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'returnDate')) && !isFeatureFlippedOff || isOnPrepareMyStay;
}

function hasTransport(stay) {
  return !!(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'departureCity') || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'arrivalCity'));
}

function hasTransfer(transfers) {
  return !!(transfers && (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(transfers.inbound) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(transfers.outbound)));
}

function findStay(booking, stayId) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays', []);

  if (!stayId && stays.length === 1) {
    return stays[0];
  }

  return stays.find(function (s) {
    return s.id === stayId;
  });
}

function isFirstStay(booking, stayId) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays.0', {}).id === stayId;
}

function findStayFormality(stayFormalities, stayId) {
  return (stayFormalities || []).find(function (s) {
    return s.stayId === stayId;
  });
}

function findTransferDetails(booking, stayId) {
  var stay = findStay(booking, stayId);
  if (!stay) return;
  return (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'transferDetails') || []).find(function (transfer) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transfer, 'inbound.date') === (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'departureDate') || Number.NaN).toString() || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transfer, 'outbound.date') === (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'returnDate') || Number.NaN).toString();
  });
}

function isMultiStay(booking) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays');
  return stays && stays.length > 1;
}

function findCurrentStay(booking) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays', []);
  if (stays.length === 0) return null;
  if (stays.length === 1) return stays[0];
  var now = moment__WEBPACK_IMPORTED_MODULE_1___default()();
  var res = stays.find(function (stay) {
    return stay.departureDate && stay.returnDate && Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* momentFromApiDate */ "h"])(stay.departureDate).isBefore(now) && Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* momentFromApiDate */ "h"])(stay.returnDate).isAfter(now);
  });
  return res || stays[0];
}

function isTour(stay) {
  return stay.productType === 'TOUR';
}

function isCruise(stay) {
  return stay.productType === 'CRUISE';
}

function getTranportIcon(transportType) {
  switch (transportType) {
    case 'TRAIN':
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRAIN;

    case 'BOAT':
    case 'FERRY':
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].BOAT;

    default:
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSPORT;
  }
}

function isSoldByClubmed(vendor) {
  return vendor === 'CLUBMED';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  formatPhoneNumber: formatPhoneNumber,
  getPhoneNumber: getPhoneNumber,
  getAgencyLabel: getAgencyLabel,
  getAgencyDetails: getAgencyDetails,
  getPackageIcon: getPackageIcon,
  isPastTrip: isPastTrip,
  shouldDisplayPriceDetail: shouldDisplayPriceDetail,
  shouldDisplayLinkList: shouldDisplayLinkList,
  hasTransport: hasTransport,
  hasTransfer: hasTransfer,
  isOption: isOption,
  isArchived: isArchived,
  findStay: findStay,
  isMultiStay: isMultiStay,
  findStayFormality: findStayFormality,
  findCurrentStay: findCurrentStay,
  isFirstStay: isFirstStay,
  findTransferDetails: findTransferDetails,
  isTour: isTour,
  isCruise: isCruise,
  getTranportIcon: getTranportIcon,
  isSoldByClubmed: isSoldByClubmed
});

/***/ }),

/***/ "wJdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClassWithModifiers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassModuler; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);





function getClassWithModifiers(base, modifiers) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_3__["isString"])(base)) {
    var baseTrimed = base.trim();
    return [baseTrimed].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(modifiers.map(function (modifier) {
      if (Object(lodash__WEBPACK_IMPORTED_MODULE_3__["isString"])(modifier)) {
        var modifierTrimed = modifier.trim();
        return classnames__WEBPACK_IMPORTED_MODULE_2___default()(Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, "".concat(baseTrimed, "--").concat(modifierTrimed), baseTrimed && modifierTrimed));
      }
    }))).join(' ').trim();
  }

  return '';
}

var getClassModuler = function getClassModuler(moduleName) {
  return function (className) {
    return "".concat(moduleName, "-").concat(className);
  };
};



/***/ }),

/***/ "xjFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/routes/constants.js
var constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx + 2 modules
var TrackingPageLoad = __webpack_require__("TVUe");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 16 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx + 2 modules
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/pick-your-room/PickYourRoom.util.js
var PickYourRoom_util = __webpack_require__("6rKJ");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/widgets/pick-your-room/pickYourRoom.constants.js
var pickYourRoom_constants = __webpack_require__("YlKQ");

// EXTERNAL MODULE: ./src/client/components/utils/className/className.util.js
var className_util = __webpack_require__("wJdf");

// EXTERNAL MODULE: ./src/client/components/widgets/pick-your-room/wrapper/PickYourRoomWrapper.container.js + 17 modules
var PickYourRoomWrapper_container = __webpack_require__("OJR3");

// EXTERNAL MODULE: ./src/client/components/widgets/resort-map/ResortMap.jsx + 2 modules
var ResortMap = __webpack_require__("HBuL");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/widgets/pyr-resort-request-form/PYRResortRequestForm.jsx
var PYRResortRequestForm = __webpack_require__("Dknd");

// EXTERNAL MODULE: ./src/client/views/account/dashboard/DashboardView.trackings.js
var DashboardView_trackings = __webpack_require__("j80U");

// CONCATENATED MODULE: ./src/client/views/agency/pick-your-room-view/PickYourRoomAgencyLayer.queries.js
function sendRequestPickYourRoomResortOnlyAgency(_ref) {
  var bookingId = _ref.bookingId,
      criteria = _ref.criteria,
      comment = _ref.comment,
      contactEmail = _ref.contactEmail;
  return "mutation {\n    sendRequestPickYourRoomResortOnlyAgency(bookingId: \"".concat(bookingId, "\", criteria: \"").concat(criteria, "\", comment:\"").concat(comment, "\", contactEmail:\"").concat(contactEmail, "\")\n  }");
}
// CONCATENATED MODULE: ./src/client/views/agency/pick-your-room-view/PickYourRoomAgencyForm.jsx
var __jsx = react_default.a.createElement;













function sendRequest(_ref) {
  var appContext = _ref.appContext,
      trackingsParams = _ref.trackingsParams,
      requestParams = _ref.requestParams;
  return graphqlClient["a" /* default */].runNoCacheQuery(sendRequestPickYourRoomResortOnlyAgency(requestParams), appContext, {
    requestName: requestDictionary["vb" /* CUSTOMER_BOOKING_PYR_ROOM_ONLY_REQUEST */]
  }).then(function () {
    Object(DashboardView_trackings["a" /* trackPYRResortOnlyRequest */])(trackingsParams, appContext);
  });
}

function PickYourRoomAgencyForm(_ref2) {
  var bookingId = _ref2.bookingId,
      onDisplayMapClick = _ref2.onDisplayMapClick,
      onSubmitSuccess = _ref2.onSubmitSuccess,
      onError = _ref2.onError;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: "\n      query {\n        config {\n          memberSpace {\n            pickYourRoom {\n              resortOnly {\n                seeResortMapCTA\n                selectCriteria {\n                  title\n                  criteria1\n                  criteria2\n                  criteria3\n                  criteria4\n                  criteria5\n                }\n                comment\n                sendRequestCTA\n              }\n              errors {\n                unhandled {\n                  title\n                }\n              }\n            }\n          }\n          agency {\n            pickYourRoom {\n              resortOnly {\n                introduction {\n                  title\n                  text\n                }\n                emailAddress\n                emailAddressMissing\n                priceInformation\n              }\n            }\n          }\n        }\n      }\n    ",
    cache: true,
    queryOptions: {
      requestName: requestDictionary["jb" /* CUSTOMER_BOOKING_PYR_AGENCY_FORM */],
      cacheFront: {
        key: requestDictionary["jb" /* CUSTOMER_BOOKING_PYR_AGENCY_FORM */]
      }
    }
  }),
      data = _useGQL.data,
      error = _useGQL.error,
      isLoading = _useGQL.isLoading;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  if (!data || error || isLoading) return null;
  var i18n = data.config;
  var trackingsParams = {};
  return __jsx("div", {
    className: "PYRResortOnlyLayer md:px-px60 md:pt-px30 md:pb-px60 mx-auto",
    "data-testid": "PickYourRoomAgencyForm"
  }, __jsx("div", {
    className: "md:flex"
  }, __jsx("div", {
    className: "md:w-1/3"
  }, __jsx(Notification["a" /* Notification */], {
    colorBg: "transparent",
    icon: icons["a" /* ICONS */].ROOM,
    iconWidth: "40",
    isStacked: true,
    text: Object(lodash["get"])(i18n, 'agency.pickYourRoom.resortOnly.introduction.text'),
    title: Object(lodash["get"])(i18n, 'agency.pickYourRoom.resortOnly.introduction.title')
  })), __jsx("div", {
    className: "md:w-2/3"
  }, __jsx(Capsule["a" /* Capsule */], null, __jsx("div", {
    className: "p-px15"
  }, __jsx(PYRResortRequestForm["a" /* PYRResortRequestForm */], {
    i18n: i18n,
    bookingId: bookingId,
    onSubmit: function onSubmit(requestParams) {
      return sendRequest({
        appContext: appContext,
        trackingsParams: trackingsParams,
        requestParams: requestParams
      }).then(onSubmitSuccess);
    },
    onDisplayMapClick: onDisplayMapClick,
    handleError: onError,
    agency: true
  }))))));
}
// EXTERNAL MODULE: ./src/client/views/agency/pick-your-room-view/PickYourRoomLoading.jsx
var PickYourRoomLoading = __webpack_require__("fQzP");

// CONCATENATED MODULE: ./src/client/views/agency/pick-your-room-view/PickYourRoomAgencyLayer.jsx

var PickYourRoomAgencyLayer_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var STATES = {
  idle: 'IDLE',
  loading: 'LOADING',
  mapSelection: 'MAP_SELECTION',
  form: 'FORM',
  mapVisualisation: 'MAP_VISUALISATION',
  error: 'ERROR'
};

function MapSelection(_ref) {
  var resortId = _ref.resortId,
      bookingId = _ref.bookingId,
      i18n = _ref.i18n,
      onError = _ref.onError;

  var _useState = Object(react["useState"])(null),
      booking = _useState[0],
      setBooking = _useState[1];

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: "\n      query {\n        resort(resortId:\"".concat(resortId, "\") {\n          id\n          image\n        }\n      }\n    "),
    cache: true,
    queryOptions: {
      requestName: requestDictionary["mb" /* CUSTOMER_BOOKING_PYR_GET_RESORTS */],
      cacheFront: {
        key: requestDictionary["mb" /* CUSTOMER_BOOKING_PYR_GET_RESORTS */]
      }
    }
  }),
      isLoading = _useGQL.isLoading,
      data = _useGQL.data,
      error = _useGQL.error;

  Object(react["useEffect"])(function () {
    if (data) {
      setBooking({
        information: {
          bookingId: bookingId,
          vendor: {
            isSoldByClubMed: false
          },
          stays: [{
            bookingId: bookingId,
            resort: {
              id: resortId,
              image: Object(lodash["get"])(data, 'resort.image')
            }
          }]
        }
      });
    }
  }, [data]);
  Object(react["useEffect"])(function () {
    if (error) {
      onError();
    }
  }, [error]);
  if (isLoading || !booking) return PickYourRoomAgencyLayer_jsx(PickYourRoomLoading["a" /* PickYourRoomLoading */], null);
  return PickYourRoomAgencyLayer_jsx(PickYourRoomWrapper_container["a" /* PickYourRoomWrapperContainer */], {
    dataTestId: "layer-agency-pick-your-room-map",
    stayWithVendor: _objectSpread(_objectSpread({}, Object(lodash["get"])(booking, 'information.stays.0') || {}), {}, {
      vendor: Object(lodash["get"])(booking, 'information.vendor')
    }),
    cmsContent: i18n,
    error: error ? {
      type: 'unhandled',
      reason: error
    } : null
  });
}

function PickYourRoomAgencyLayer(_ref2) {
  var i18n = _ref2.i18n,
      onClose = _ref2.onClose,
      bookingId = _ref2.bookingId,
      resortId = _ref2.resortId,
      dataTestId = _ref2.dataTestId,
      availableRooms = _ref2.availableRooms,
      onError = _ref2.onError;

  var _useState2 = Object(react["useState"])(STATES.idle),
      currentState = _useState2[0],
      setCurrentState = _useState2[1];

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var layerTitle = Object(src_i18n["g" /* t */])('memberSpace.prepareMyStay.pickYourRoom.title');

  var render = function render(children) {
    return PickYourRoomAgencyLayer_jsx(Layer["b" /* Layer */], {
      ariaLabel: layerTitle,
      ariaLabelledby: identifiers_constants["g" /* ID_LAYER_HEADER__PLE__PYR_AGENCY */],
      buttonLeft: {
        iconName: icons["a" /* ICONS */].LEFT_ARROW,
        onClick: function onClick() {
          switch (currentState) {
            case STATES.mapVisualisation:
              return setCurrentState(STATES.form);

            default:
              return onClose();
          }
        }
      },
      className: Object(className_util["b" /* getClassWithModifiers */])('PickYourRoomLayer', ['agency']),
      closeLabel: Object(src_i18n["g" /* t */])('common.close'),
      dataTestId: dataTestId,
      hasAnimateEnter: true,
      header: PickYourRoomAgencyLayer_jsx(Title["a" /* Title */], {
        id: identifiers_constants["g" /* ID_LAYER_HEADER__PLE__PYR_AGENCY */],
        theme: "title-brand-3",
        className: "text-center"
      }, layerTitle),
      name: pickYourRoom_constants["a" /* PYR_LAYER_NAME */],
      onClose: onClose
    }, children);
  };

  Object(react["useEffect"])(function () {
    if (!availableRooms) {
      setCurrentState(STATES.idle);
    } else if (availableRooms.length > 0) {
      setCurrentState(STATES.mapSelection);
    } else if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('pickYourRoom.enableAuthenticatedAgency')) {
      setCurrentState(STATES.form);
    } else {
      setCurrentState(STATES.error);
    }
  }, [availableRooms]);

  switch (currentState) {
    case STATES.loading:
      {
        return PickYourRoomAgencyLayer_jsx(PickYourRoomLoading["a" /* PickYourRoomLoading */], null);
      }

    case STATES.error:
      {
        return render(PickYourRoomAgencyLayer_jsx("div", {
          className: "flex justify-center items-center h-full"
        }, PickYourRoomAgencyLayer_jsx(Notification["a" /* Notification */], {
          title: Object(lodash["get"])(i18n, 'memberSpace.pickYourRoom.errors.unhandled.title'),
          text: Object(lodash["get"])(i18n, 'memberSpace.pickYourRoom.errors.unhandled.subtitle')
        })));
      }

    case STATES.mapSelection:
      {
        return render(PickYourRoomAgencyLayer_jsx(MapSelection, {
          bookingId: bookingId,
          resortId: resortId,
          i18n: i18n,
          onError: function onError() {
            if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('pickYourRoom.enableAuthenticatedAgency')) {
              setCurrentState(STATES.form);
            } else {
              setCurrentState(STATES.error);
            }
          }
        }));
      }

    case STATES.form:
      {
        return render(PickYourRoomAgencyLayer_jsx(PickYourRoomAgencyForm, {
          bookingId: bookingId,
          resortId: resortId,
          onDisplayMapClick: function onDisplayMapClick() {
            return setCurrentState(STATES.mapVisualisation);
          },
          onSubmitSuccess: function onSubmitSuccess() {
            dispatch({
              type: 'PICK_YOUR_ROOM_AGENCY_SUCCESS',
              payload: {
                toastLabel: Object(lodash["get"])(i18n, 'memberSpace.pickYourRoom.resortOnly.confirmationMessage')
              }
            });
            onClose();
          },
          onError: onError
        }));
      }

    case STATES.mapVisualisation:
      {
        return render(PickYourRoomAgencyLayer_jsx(ResortMap["a" /* ResortMap */], {
          resortId: resortId,
          withBuildingList: true
        }));
      }

    default:
      return render(null);
  }
}
// CONCATENATED MODULE: ./src/client/views/agency/pick-your-room-view/PickYourRoomAgencyView.jsx
var PickYourRoomAgencyView_jsx = react_default.a.createElement;





























function Form(_ref) {
  var PLEPrefix = _ref.PLEPrefix,
      _onSubmit = _ref.onSubmit;

  var _useState = Object(react["useState"])(false),
      isSubmiting = _useState[0],
      setIsSubmiting = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])();
  return PickYourRoomAgencyView_jsx(formik_esm["d" /* Formik */], {
    "data-selector": "PickYourRoomAgency-Form",
    initialValues: {
      bookingId: '',
      resortId: ''
    },
    validationSchema: lib["object"]().shape({
      bookingId: lib["number"]().required(),
      resortId: lib["string"]().required()
    }),
    onSubmit: function onSubmit(_ref2) {
      var bookingId = _ref2.bookingId,
          resortId = _ref2.resortId;
      if (isSubmiting) return;
      setIsSubmiting(true);

      _onSubmit({
        bookingId: bookingId.trim(),
        resortId: resortId
      }).finally(function () {
        setIsSubmiting(false);
      });
    }
  }, PickYourRoomAgencyView_jsx(formik_esm["c" /* Form */], {
    className: "PickYourRoomAgency-Form"
  }, PickYourRoomAgencyView_jsx("div", null, PickYourRoomAgencyView_jsx(FormikInput["a" /* FormikInput */], {
    name: "resortId",
    type: "select",
    label: Object(src_i18n["g" /* t */])('agency.pickYourRoom.resortLabel'),
    placeholder: Object(src_i18n["g" /* t */])('agency.pickYourRoom.resortLabel'),
    options: [{
      name: 'Marrakech',
      value: 'MPAC'
    }, {
      name: 'La Palmyre',
      value: 'LPAC'
    }, {
      name: 'Turkoise',
      value: 'TURC'
    }, {
      name: 'Columbus',
      value: 'COLC'
    }, {
      name: 'Kani',
      value: 'KANC'
    }, {
      name: 'Cancun',
      value: 'CANC'
    }, {
      name: 'Miches',
      value: 'MPEC'
    }, {
      name: 'Punta Cana',
      value: 'PCAC'
    }],
    hideErrorMessage: true,
    dataTestId: "input-resortId"
  })), PickYourRoomAgencyView_jsx("div", null, PickYourRoomAgencyView_jsx(FormikInput["a" /* FormikInput */], {
    name: "bookingId",
    label: Object(src_i18n["g" /* t */])('agency.pickYourRoom.bookingNumberLabel'),
    type: "text",
    isRequired: true,
    hideErrorMessage: true,
    dataTestId: "input-bookingId"
  })), PickYourRoomAgencyView_jsx("div", {
    className: "flex justify-end items-end"
  }, PickYourRoomAgencyView_jsx(Button["a" /* Button */], {
    isLoading: isSubmiting,
    className: "w-full",
    dataSelector: "PickYourRoomAgency-button",
    type: "submit",
    onClick: function onClick() {
      track({
        categoryGA: PLEPrefix,
        actionGA: 'CTA_accessSellersMap',
        labelGA: "".concat(PLEPrefix, "_pickYourRoom_sellersMap")
      });
    },
    dataTestId: "button-submit"
  }, Object(src_i18n["g" /* t */])('agency.pickYourRoom.showMapCTA')))));
}

var initialState = {
  isLayerVisible: false,
  bookingId: '',
  resortId: '',
  availableRooms: []
};
var PickYourRoomAgencyView_PickYourRoomAgencyView = function PickYourRoomAgencyView() {
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useState2 = Object(react["useState"])(initialState),
      state = _useState2[0],
      setState = _useState2[1];

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var title = 'Pick Your Room';
  var PLEPrefix = Object(utils["a" /* getPLECategoryGA */])(appContext.isUserQuickLogged);
  var props = {
    pageName: "".concat(PLEPrefix.toLowerCase(), "_pickYourRoom_sellersMap")
  };

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: "query {\n      config {\n        common {\n          close\n        }\n        memberSpace {\n          prepareMyStay {\n            pickYourRoom {\n              title\n            }\n          }\n          ".concat(PickYourRoom_util["a" /* cmsQueryPart */], "\n        }\n        agency {\n          pickYourRoom {\n            resortLabel\n            bookingNumberLabel\n            showMapCTA\n            title\n          }\n        }\n      }\n    }"),
    cache: true,
    queryOptions: {
      requestName: requestDictionary["kb" /* CUSTOMER_BOOKING_PYR_AGENCY_VIEW_RESOLVER */],
      cacheFront: {
        key: requestDictionary["kb" /* CUSTOMER_BOOKING_PYR_AGENCY_VIEW_RESOLVER */]
      }
    },
    map: function map(i18nData) {
      Object(src_i18n["a" /* addTranslationKeys */])(i18nData.config);
      return i18nData;
    }
  }),
      isLoading = _useGQL.isLoading,
      data = _useGQL.data,
      error = _useGQL.error;

  var notifyError = function notifyError() {
    return dispatch({
      type: 'PICK_YOUR_ROOM_AGENCY',
      payload: {
        toastLabel: Object(src_i18n["g" /* t */])('memberSpace.pickYourRoom.errors.unhandled.title')
      }
    });
  };

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  Object(react["useEffect"])(function () {
    if (!appContext.isSellerLogged && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('pickYourRoom.enableAuthenticatedAgency')) {
      Object(ple_utils["o" /* redirectOnLoginPage */])({
        redirectPath: location.pathname,
        isSeller: true,
        locale: appContext.locale
      });
    }
  }, [appContext.isSellerLogged]);

  if (isLoading) {
    return PickYourRoomAgencyView_jsx(PickYourRoomLoading["a" /* PickYourRoomLoading */], null);
  }

  if (!appContext.isSellerLogged && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('pickYourRoom.enableAuthenticatedAgency')) return null;

  if (error || !data) {
    return PickYourRoomAgencyView_jsx("div", {
      className: "PickYourRoomAgency-View"
    }, PickYourRoomAgencyView_jsx(TrackingPageLoad["a" /* TrackingPageLoad */], props), PickYourRoomAgencyView_jsx(head_default.a, null, PickYourRoomAgencyView_jsx("title", {
      key: "title"
    }, title)), PickYourRoomAgencyView_jsx(Hero["a" /* Hero */], {
      size: "medium",
      url: "https://ns.clubmed.com/icp/1-MEDIA/01.VILLAGES/1.1MER/BALI/31-30-29-28-27-26-25-24-23-22-21-20-19-18-17-16-15-14-13-12-11-10-9-8-7-6-5-4-3-2-1-PHOTOS/BALCG218002.jpg"
    }), PickYourRoomAgencyView_jsx("div", {
      className: "PickYourRoomAgency-Wrapper"
    }, PickYourRoomAgencyView_jsx("div", {
      className: "my-px30 flex justify-center"
    }, PickYourRoomAgencyView_jsx(Notification["a" /* Notification */], {
      text: error ? Object(lodash["get"])(error, 'errors.0.message') : 'NO DATAS!',
      icon: icons["a" /* ICONS */].WARNING,
      color: colors["a" /* COLORS */].RED,
      hasBorder: true,
      dataTestId: "dashboard-generic-error"
    }))));
  }

  var config = data.config;
  return PickYourRoomAgencyView_jsx("div", {
    className: "PickYourRoomAgency-View"
  }, PickYourRoomAgencyView_jsx(TrackingPageLoad["a" /* TrackingPageLoad */], props), PickYourRoomAgencyView_jsx(head_default.a, null, PickYourRoomAgencyView_jsx("title", {
    key: "title"
  }, title)), PickYourRoomAgencyView_jsx(Hero["a" /* Hero */], {
    size: "medium",
    url: "https://ns.clubmed.com/icp/1-MEDIA/01.VILLAGES/1.1MER/BALI/31-30-29-28-27-26-25-24-23-22-21-20-19-18-17-16-15-14-13-12-11-10-9-8-7-6-5-4-3-2-1-PHOTOS/BALCG218002.jpg"
  }), PickYourRoomAgencyView_jsx("div", {
    className: "PickYourRoomAgency-Wrapper"
  }, PickYourRoomAgencyView_jsx("header", {
    className: "mb-px15"
  }, PickYourRoomAgencyView_jsx("h2", {
    className: "PickYourRoomAgency-title font-brand"
  }, "Pick Your Room"), PickYourRoomAgencyView_jsx("h3", {
    className: "PickYourRoomAgency-subtitle font-brand"
  }, Object(src_i18n["g" /* t */])('agency.pickYourRoom.title'))), PickYourRoomAgencyView_jsx(Form, {
    PLEPrefix: PLEPrefix,
    onSubmit: function onSubmit(_ref3) {
      var bookingId = _ref3.bookingId,
          resortId = _ref3.resortId;
      return graphqlClient["a" /* default */].runNoCacheQuery("query {\n                  pickYourRoom {\n                    roomSelectionServices(bookingId : \"".concat(bookingId, "\", resortId : \"").concat(resortId, "\") {\n                      data {\n                        quantity\n                      }\n                    }\n                  }\n                }"), appContext, {
        requestName: requestDictionary["pb" /* CUSTOMER_BOOKING_PYR_GET_ROOM_SELECTION_AGENCY */]
      }).then(function (res) {
        var availableRooms = Object(lodash["get"])(res, 'pickYourRoom.roomSelectionServices.data') || [];
        setState({
          bookingId: bookingId,
          resortId: resortId,
          isLayerVisible: Boolean(bookingId && resortId),
          availableRooms: availableRooms
        });
      }).catch(function () {
        notifyError();
      });
    }
  })), state.isLayerVisible && PickYourRoomAgencyView_jsx(PickYourRoomAgencyLayer, {
    dataTestId: "layer-agency-pick-your-room",
    bookingId: state.bookingId,
    resortId: state.resortId // $FlowFixMe
    ,
    availableRooms: state.availableRooms,
    i18n: config,
    onBack: function onBack() {
      return setState(initialState);
    },
    onClose: function onClose() {
      return setState(initialState);
    },
    onError: function onError(err) {
      if (Object(ple_utils["l" /* hasAuthResponseError */])(err)) {
        Object(ple_utils["o" /* redirectOnLoginPage */])({
          redirectPath: location.pathname,
          isSeller: true,
          locale: appContext.locale
        });
      }
    }
  }));
};
PickYourRoomAgencyView_PickYourRoomAgencyView.requireAuthentication = false;
PickYourRoomAgencyView_PickYourRoomAgencyView.disableHeader = true;
PickYourRoomAgencyView_PickYourRoomAgencyView.pageId = constants["t" /* PLE_PICK_YOUR_ROOM_AGENCY_PAGE_ID */];
PickYourRoomAgencyView_PickYourRoomAgencyView.pageType = tracking_constants["w" /* STATIC_PAGE_TYPES */].PLE;
// CONCATENATED MODULE: ./pages/account/pickYourRoomAgencyView.js

/* harmony default export */ var pickYourRoomAgencyView = __webpack_exports__["default"] = (PickYourRoomAgencyView_PickYourRoomAgencyView);

/***/ }),

/***/ "ycRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOOKING_PAYMENT_STATUS_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOKING_PAYMENT_STATUS_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_PAYMENT_STATUS_CART; });
var BOOKING_PAYMENT_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_PAYMENT_STATUS_OPTION = 'OPTION';
var BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE = 'PACKAGE_UPGRADE';
var BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE = 'ADDITIONAL_SERVICE';
var BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM = 'PICK_YOUR_ROOM';
var BOOKING_PAYMENT_STATUS_CART = 'CART';


/***/ })

},[["4M6q",1,2,3,5,0,4,6,7,8,9,10,12,13,16,15,18,20,22,38]]]);